// ---------- PAGE URL RESOLVER (Shopify theme routes vs static preview) ----------
window.GALLO_URL = (function () {
  var S = !!(window.routes && window.routes.cart_add_url);
  return {
    shopify: S,
    customize:  S ? '/pages/customize' : 'customize.html',
    diamonds:   S ? '/pages/diamonds' : 'diamonds.html',
    setting:    S ? '/collections/engagement-ring-settings' : 'setting.html',
    engagement: S ? '/collections/engagement-ring-rtw' : 'engagement.html',
    wedding:    S ? '/collections/womens-wedding-bands' : 'wedding.html',
    product:    S ? '/collections/all' : 'product.html'
  };
})();

// ---------- SETTINGS CATALOG (shared by customize.html + setting.html) ----------
window.GALLO_CDN = 'https://cdn.shopify.com/s/files/1/0680/5192/7087/';
window.GALLO_METAL_NAMES = { yellow:'14K Yellow Gold', white:'14K White Gold', rose:'14K Rose Gold', platinum:'Platinum' };
window.GALLO_SETTINGS = [
  {
    "sku": "solitaire-engagement-ring-1",
    "name": "Solitaire",
    "sub": "Round \u00b7 14K Gold / Rose",
    "price": 1000,
    "shape": "round",
    "metals": [
      "white",
      "yellow",
      "rose"
    ],
    "img": "files/GL0103-1.jpg?v=1766244607",
    "alt": "files/GL0103-6.jpg?v=1766244607",
    "metalImgs": {
      "white": "files/GL0103-1.jpg?v=1766244607",
      "yellow": "files/GL0103-8.jpg?v=1766244607",
      "rose": "files/GL0103-15.jpg?v=1766244607"
    }
  },
  {
    "sku": "petite-u-prong-engagement-ring",
    "name": "Petite U Prong",
    "sub": "Round \u00b7 14K Gold / Rose",
    "price": 1289,
    "shape": "round",
    "metals": [
      "white",
      "yellow",
      "rose"
    ],
    "img": "files/GL0250-RING-1_aa5f56f6-8a76-49ba-a7f2-d7c59f07f0c2.jpg?v=1766244547",
    "alt": "files/GL0250-RING-2.jpg?v=1766244547",
    "metalImgs": {
      "white": "files/GL0250-RING-1_aa5f56f6-8a76-49ba-a7f2-d7c59f07f0c2.jpg?v=1766244547",
      "yellow": "files/GL0250-RING-8.jpg?v=1766244547",
      "rose": "files/GL0250-RING-15.jpg?v=1766244606"
    }
  },
  {
    "sku": "hidden-halo-pear-shape-engagement-ring",
    "name": "Hidden Halo Pear Shape",
    "sub": "Pear \u00b7 14K Gold / Rose",
    "price": 1299,
    "shape": "pear",
    "metals": [
      "yellow",
      "white",
      "rose"
    ],
    "img": "files/85296.alt.jpg?v=1766244007",
    "alt": "files/85296.angle.alt.jpg?v=1766244007",
    "metalImgs": {
      "yellow": "files/85296.alt.jpg?v=1766244007",
      "white": "files/85296.jpg?v=1766244007",
      "rose": "files/85296.alt1.jpg?v=1766244007"
    }
  },
  {
    "sku": "twisted-vine-lab-diamond-engagement-ring",
    "name": "Twisted Vine Lab Diamond",
    "sub": "Round \u00b7 14K Gold / Rose",
    "price": 1299,
    "shape": "round",
    "metals": [
      "yellow",
      "white",
      "rose"
    ],
    "img": "files/51173-E.alt_2.jpg?v=1766244068",
    "alt": "files/51173-E.set.alt_2.jpg?v=1766244068",
    "metalImgs": {
      "yellow": "files/51173-E.alt_2.jpg?v=1766244068",
      "white": "files/51173-E_1.jpg?v=1766244068",
      "rose": "files/51173-E.alt1_2.jpg?v=1766244068"
    }
  },
  {
    "sku": "underhalo-pear-engagement-ring-0-25ct",
    "name": "Underhalo Pear",
    "sub": "Pear \u00b7 14K Gold / Rose",
    "price": 1299,
    "shape": "pear",
    "metals": [
      "yellow",
      "white",
      "rose"
    ],
    "img": "files/85451.angle_1.jpg?v=1766244308",
    "alt": "files/85451_1.jpg?v=1766244308",
    "metalImgs": {
      "yellow": "files/85451.angle.alt_1_1.jpg?v=1766244309",
      "white": "files/85451.angle_1.jpg?v=1766244308",
      "rose": "files/85451.angle.alt1_1.jpg?v=1766244308"
    }
  },
  {
    "sku": "underhalo-engagement-ring-0-20ct",
    "name": "Underhalo",
    "sub": "Round \u00b7 14K Gold / Rose",
    "price": 1299,
    "shape": "round",
    "metals": [
      "yellow",
      "white",
      "rose"
    ],
    "img": "files/85453.angle_2_1.jpg?v=1766244308",
    "alt": "files/85453_2.jpg?v=1766244309",
    "metalImgs": {
      "yellow": "files/85453.angle.alt_2_1.jpg?v=1766244309",
      "white": "files/85453.angle_2_1.jpg?v=1766244308",
      "rose": "files/85453.angle.alt1_2.jpg?v=1766244309"
    }
  },
  {
    "sku": "underhalo-engagement-ring",
    "name": "Underhalo",
    "sub": "Round \u00b7 14K Gold / Rose",
    "price": 1339,
    "shape": "round",
    "metals": [
      "yellow",
      "white",
      "rose"
    ],
    "img": "files/GL0080-8.jpg?v=1766244367",
    "alt": "files/GL0080-9.jpg?v=1766244368",
    "metalImgs": {
      "yellow": "files/GL0103-8_95483aa1-dabe-4642-ab18-a29001ee062e.jpg?v=1766244666",
      "white": "files/GL0103-1_b513fb17-ccdd-470d-b661-99c5a1b0b1d4.jpg?v=1766244726",
      "rose": "files/GL0103-15_89333f32-01f3-41e6-8396-c7ffe3229ef4.jpg?v=1766244726"
    }
  },
  {
    "sku": "u-prong-engagement-ring-4",
    "name": "U Prong",
    "sub": "Round \u00b7 14K Gold / Rose",
    "price": 1349,
    "shape": "round",
    "metals": [
      "yellow",
      "white",
      "rose"
    ],
    "img": "files/GL0248-RING-8.jpg?v=1766244487",
    "alt": "files/GL0248-RING-9.jpg?v=1766244488",
    "metalImgs": {
      "yellow": "files/GL0248-RING-8.jpg?v=1766244487",
      "white": "files/GL0248-RING-1.jpg?v=1766244487",
      "rose": "files/GL0248-RING-15.jpg?v=1766244546"
    }
  },
  {
    "sku": "prong-set-emerald-cut-hidden-halo-engagement-ring",
    "name": "Prong Set Emerald Cut Hidden Halo",
    "sub": "Emerald \u00b7 14K Gold / Rose",
    "price": 1449,
    "shape": "emerald",
    "metals": [
      "yellow",
      "white",
      "rose"
    ],
    "img": "files/85476.angle.alt.jpg?v=1766917421",
    "alt": "files/85476.alt.jpg?v=1766917421",
    "metalImgs": {
      "yellow": "files/85476.angle.alt.jpg?v=1766917421",
      "white": "files/85476.angle.jpg?v=1766917421",
      "rose": "files/85476.angle.alt1.jpg?v=1766917421"
    }
  },
  {
    "sku": "underhalo-engagement-ring-0-65ct-1",
    "name": "Underhalo",
    "sub": "Round \u00b7 14K Gold / Rose",
    "price": 1449,
    "shape": "round",
    "metals": [
      "yellow",
      "white",
      "rose"
    ],
    "img": "files/85478.angle.alt_1.jpg?v=1766244367",
    "alt": "files/85478.alt_1.jpg?v=1766244367",
    "metalImgs": {
      "yellow": "files/85478.angle.alt_1.jpg?v=1766244367",
      "white": "files/85478.angle_1.jpg?v=1766244367",
      "rose": "files/85478.angle.alt1_1.jpg?v=1766244367"
    }
  },
  {
    "sku": "underhalo-engagement-ring-0-65ct",
    "name": "Underhalo",
    "sub": "Round \u00b7 14K Gold / Rose",
    "price": 1449,
    "shape": "round",
    "metals": [
      "yellow",
      "white",
      "rose"
    ],
    "img": "files/85479.angle.alt.jpg?v=1766244367",
    "alt": "files/85479.alt.jpg?v=1766244367",
    "metalImgs": {
      "yellow": "files/85479.angle.alt.jpg?v=1766244367",
      "white": "files/85479.angle.jpg?v=1766244367",
      "rose": "files/85479.angle.alt1.jpg?v=1766244367"
    }
  },
  {
    "sku": "classic-prong-set-engagement-ring",
    "name": "Classic Prong Set",
    "sub": "Round \u00b7 14K Gold / Rose",
    "price": 1499,
    "shape": "round",
    "metals": [
      "white",
      "yellow",
      "rose"
    ],
    "img": "files/GL0256-1_a06399f3-152d-48ce-8781-f6be09b48919.jpg?v=1778687005",
    "alt": "files/GL0256-2_2157d5ed-0340-4080-8079-1ca525302a62.jpg?v=1778687005",
    "metalImgs": {
      "white": "files/GL0256-1_a06399f3-152d-48ce-8781-f6be09b48919.jpg?v=1778687005",
      "yellow": "files/GL0256-8_eadad5e6-1069-4a78-9ebe-f7a79d5c78e0.jpg?v=1778687005",
      "rose": "files/GL0256-15_ca3b6b5c-4c7f-4043-99e7-fa33fae1ecb1.jpg?v=1778687005"
    }
  },
  {
    "sku": "marquise-diamond-engagement-ring",
    "name": "Marquise Diamond",
    "sub": "Marquise \u00b7 14K Gold / Rose",
    "price": 1499,
    "shape": "marquise",
    "metals": [
      "yellow",
      "white",
      "rose"
    ],
    "img": "files/51179-E.alt.jpg?v=1766244126",
    "alt": "files/51179-E.set.alt.jpg?v=1766244126",
    "metalImgs": {
      "yellow": "files/51179-E.alt.jpg?v=1766244126",
      "white": "files/51179-E.jpg?v=1766244126",
      "rose": "files/51179-E.alt1_0.jpg?v=1766244126"
    }
  },
  {
    "sku": "u-prong-engagement-ring-2",
    "name": "U Prong",
    "sub": "Round \u00b7 14K Gold / Rose",
    "price": 1499,
    "shape": "round",
    "metals": [
      "yellow",
      "white",
      "rose"
    ],
    "img": "files/GL0323-RING-1.jpg?v=1766244547",
    "alt": "files/GL0323-RING-2.jpg?v=1766244547",
    "metalImgs": {
      "yellow": "files/GL0323-RING-8.jpg?v=1766244547",
      "white": "files/GL0323-RING-1.jpg?v=1766244547",
      "rose": "files/GL0323-RING-15.jpg?v=1766244606"
    }
  },
  {
    "sku": "under-halo-engagement-ring",
    "name": "Under Halo",
    "sub": "Round \u00b7 14K Gold / Rose",
    "price": 1500,
    "shape": "round",
    "metals": [
      "white",
      "yellow",
      "rose"
    ],
    "img": "files/GL0176-1.jpg?v=1766244607",
    "alt": "files/GL0176-5.jpg?v=1766244607",
    "metalImgs": {
      "white": "files/GL0176-1.jpg?v=1766244607",
      "yellow": "files/GL0176-8.jpg?v=1766244607",
      "rose": "files/GL0176-15.jpg?v=1766244607"
    }
  },
  {
    "sku": "alberta-engagement-ring",
    "name": "Engagement Ring",
    "sub": "Round \u00b7 14K Gold / Rose",
    "price": 1500,
    "shape": "round",
    "metals": [
      "white",
      "yellow",
      "rose"
    ],
    "img": "files/GL0298-1.jpg?v=1766244607",
    "alt": "files/GL0298-2.jpg?v=1766244607",
    "metalImgs": {
      "white": "files/GL0292-1_9942c63f-fff0-482d-9a30-8cfd120f79df.jpg?v=1766244665",
      "yellow": "files/GL0292-8.jpg?v=1766244607",
      "rose": "files/GL0292-15.jpg?v=1766244607"
    }
  },
  {
    "sku": "double-hidden-halo-pear-engagement-ring",
    "name": "Double Hidden Halo Pear",
    "sub": "Pear \u00b7 14K Gold / Rose",
    "price": 1599,
    "shape": "pear",
    "metals": [
      "yellow",
      "white",
      "rose"
    ],
    "img": "files/85451.angle.alt.jpg?v=1766917426",
    "alt": "files/85451.set.alt.jpg?v=1766917426",
    "metalImgs": {
      "yellow": "files/85451.angle.alt.jpg?v=1766917426",
      "white": "files/85451.angle.jpg?v=1766917426",
      "rose": "files/85451.angle.alt1.jpg?v=1766917425"
    }
  },
  {
    "sku": "marquise-round-accented-engagement-ring",
    "name": "Marquise & Round Accented",
    "sub": "Round \u00b7 14K Gold / Rose",
    "price": 1599,
    "shape": "round",
    "metals": [
      "yellow",
      "white",
      "rose"
    ],
    "img": "files/85134.alt.jpg?v=1766244007",
    "alt": "files/85134.ver.alt.jpg?v=1766244007",
    "metalImgs": {
      "yellow": "files/85134.alt.jpg?v=1766244007",
      "white": "files/85134.jpg?v=1766244007",
      "rose": "files/85134.alt1.jpg?v=1766244066"
    }
  },
  {
    "sku": "two-stone-cocktail-ring-2ct",
    "name": "The Toi Et Moi Ring 2ct",
    "sub": "Round \u00b7 14K Gold / Rose",
    "price": 1699,
    "shape": "round",
    "metals": [
      "yellow",
      "white",
      "rose"
    ],
    "img": "files/85364.angle.alt.jpg?v=1766244368",
    "alt": "files/85364.alt.jpg?v=1766244368",
    "metalImgs": {
      "yellow": "files/85364.angle.alt.jpg?v=1766244368",
      "white": "files/85364.angle.jpg?v=1766244367",
      "rose": "files/85364.angle.alt1.jpg?v=1766244367"
    }
  },
  {
    "sku": "two-stone-cocktail-ring-3ct",
    "name": "The Toi Et Moi Ring 3ct",
    "sub": "Round \u00b7 14K Gold / Rose",
    "price": 1999,
    "shape": "round",
    "metals": [
      "yellow",
      "white",
      "rose"
    ],
    "img": "files/85363.angle.alt.jpg?v=1766244367",
    "alt": "files/85363.alt.jpg?v=1766244367",
    "metalImgs": {
      "yellow": "files/85363.angle.alt.jpg?v=1766244367",
      "white": "files/85363.angle.jpg?v=1766244367",
      "rose": "files/85363.angle.alt1.jpg?v=1766244367"
    }
  },
  {
    "sku": "u-prong-engagement-ring-3",
    "name": "U Prong",
    "sub": "Pear \u00b7 14K Gold / Rose",
    "price": 1999,
    "shape": "pear",
    "metals": [
      "yellow",
      "white",
      "rose"
    ],
    "img": "files/GL0354-RING-1.jpg?v=1766244547",
    "alt": "files/GL0354-RING-2.jpg?v=1766244547",
    "metalImgs": {
      "yellow": "files/GL0354-RING-8.jpg?v=1766244547",
      "white": "files/GL0354-RING-1.jpg?v=1766244547",
      "rose": "files/GL0354-RING-15.jpg?v=1766244606"
    }
  },
  {
    "sku": "u-prong-engagement-ring-1",
    "name": "U Prong",
    "sub": "Round \u00b7 14K Gold / Rose",
    "price": 1999,
    "shape": "round",
    "metals": [
      "yellow",
      "white",
      "rose"
    ],
    "img": "files/GL0318-RING-1.jpg?v=1766244547",
    "alt": "files/GL0318-RING-2.jpg?v=1766244547",
    "metalImgs": {
      "yellow": "files/GL0318-RING-8.jpg?v=1766244547",
      "white": "files/GL0318-RING-1.jpg?v=1766244547",
      "rose": "files/GL0318-RING-15.jpg?v=1766244606"
    }
  },
  {
    "sku": "u-prong-engagement-ring",
    "name": "U-Prong",
    "sub": "Round \u00b7 14K Gold / Rose",
    "price": 2500,
    "shape": "round",
    "metals": [
      "white",
      "yellow",
      "rose"
    ],
    "img": "files/GL0242-RING-1_fb4b4c78-425f-4c82-b65e-cf774a2e6cdb.jpg?v=1766244607",
    "alt": "files/GL0242-RING-3_810a4315-073e-462b-b3cb-ea3b5acf7399.jpg?v=1766244607",
    "metalImgs": {
      "white": "files/GL0242-RING-1_fb4b4c78-425f-4c82-b65e-cf774a2e6cdb.jpg?v=1766244607",
      "yellow": "files/GL0242-RING-8_71c3d04a-f6ad-4671-865c-395a5964ed83.jpg?v=1766244607",
      "rose": "files/GL0242-RING-15_8c35fb02-5dfd-414b-90bb-beac2fc538e6.jpg?v=1766244607"
    }
  }
];

/* =====================================================
   GALLO JEWELRY — site interactions
   ===================================================== */
(function () {
  'use strict';

  // ---------- CART STATE ----------
  // On the Shopify theme we drive the drawer from Shopify's live AJAX Cart API.
  // Off-Shopify (the static design preview) we fall back to the localStorage demo cart.
  const SHOPIFY = !!(window.routes && window.routes.cart_add_url);
  const CART_KEY = 'gallo.cart.v1';
  let cart = loadCart();

  function loadCart() {
    if (SHOPIFY) return { items: [], count: 0, subtotal: 0 };
    try {
      const raw = localStorage.getItem(CART_KEY);
      return raw ? JSON.parse(raw) : { items: [] };
    } catch (e) {
      return { items: [] };
    }
  }
  function saveCart() {
    if (SHOPIFY) return;
    try { localStorage.setItem(CART_KEY, JSON.stringify(cart)); } catch (e) {}
  }
  function cartCount() {
    if (SHOPIFY) return cart.count || 0;
    const seen = new Set();
    let n = 0;
    for (const item of cart.items) {
      if (item.bundleId) {
        if (!seen.has(item.bundleId)) { seen.add(item.bundleId); n++; }
      } else { n += item.quantity; }
    }
    return n;
  }
  function cartSubtotal() {
    if (SHOPIFY) return cart.subtotal || 0;
    return cart.items.reduce((s, i) => s + (i.price * i.quantity), 0);
  }
  function fmtMoney(n) {
    return '$' + n.toLocaleString('en-US', { maximumFractionDigits: 0 });
  }

  // ---------- SHOPIFY AJAX CART ----------
  function applyShopifyCart(data) {
    if (!data || !data.items) return;
    cart.count = data.item_count;
    cart.subtotal = (data.items_subtotal_price != null ? data.items_subtotal_price : data.total_price || 0) / 100;
    cart.items = data.items.map(function (it) {
      return {
        lineKey: it.key,
        quantity: it.quantity,
        title: it.product_title || it.title,
        variantTitle: (it.variant_title && it.variant_title !== 'Default Title') ? it.variant_title : '',
        price: it.final_price / 100,
        linePrice: it.final_line_price / 100,
        imageUrl: it.image,
        url: it.url,
        properties: it.properties || {}
      };
    });
  }
  async function refreshCart(open) {
    if (!SHOPIFY) return;
    try {
      const res = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
      applyShopifyCart(await res.json());
    } catch (e) {}
    renderCartDrawer();
    updateCartCounts();
    if (open) openCart();
  }
  async function shopifyChangeLine(lineKey, quantity) {
    try {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: lineKey, quantity: quantity })
      });
      applyShopifyCart(await res.json());
    } catch (e) {}
    renderCartDrawer();
    updateCartCounts();
  }
  async function shopifyAddVariant(variantId, quantity, properties) {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: quantity || 1, properties: properties || {} }] })
    });
    if (!res.ok) {
      const err = await res.json().catch(function () { return {}; });
      throw new Error(err.description || 'Could not add to cart');
    }
    await refreshCart(true);
  }

  // ---------- HEADER CART COUNT ----------
  function updateCartCounts() {
    const n = cartCount();
    document.querySelectorAll('[data-cart-count]').forEach(el => {
      el.textContent = n;
      el.style.display = n > 0 ? '' : 'none';
    });
    document.querySelectorAll('[data-utility-cart]').forEach(el => {
      el.textContent = `Cart (${n})`;
    });
  }
  updateCartCounts();

  // ---------- ADD TO CART (called from PDP / Customizer) ----------
  window.galloAddToCart = function (item) {
    if (SHOPIFY && item && item.variantId) {
      shopifyAddVariant(item.variantId, item.quantity || 1, item.properties)
        .then(function () { showToast((item.title || 'Item') + ' added to cart'); })
        .catch(function (err) { showToast(err.message || 'Could not add to cart'); });
      return;
    }
    cart.items.push({
      lineId: crypto.randomUUID(),
      quantity: 1,
      ...item
    });
    saveCart();
    renderCartDrawer();
    updateCartCounts();
    openCart();
    showToast(`${item.title} added to cart`);
  };

  // Intercept the native PDP product form so add-to-cart opens the drawer (no full-page reload)
  if (SHOPIFY) {
    document.addEventListener('submit', function (e) {
      const form = e.target.closest('form[action="/cart/add"], form[action$="/cart/add"]');
      if (!form) return;
      e.preventDefault();
      const btn = form.querySelector('[name="add"]');
      const orig = btn ? btn.innerHTML : '';
      if (btn) { btn.disabled = true; btn.innerHTML = 'Adding…'; }
      fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(form) })
        .then(function (r) { return r.ok ? r.json() : r.json().then(function (er) { return Promise.reject(er); }); })
        .then(function () { return refreshCart(true); })
        .catch(function (er) { showToast((er && er.description) || 'Could not add to cart'); })
        .finally(function () { if (btn) { btn.disabled = false; btn.innerHTML = orig; } });
    });
  }

  // Bundle add (Customizer)
  window.galloAddBundleToCart = function (bundle) {
    bundle.items.forEach(it => {
      cart.items.push({
        lineId: crypto.randomUUID(),
        bundleId: bundle.bundleId,
        bundleRole: it.kind,
        bundleMeta: { displayName: bundle.displayName, totalPrice: bundle.totalPrice, thumbnail: bundle.thumbnail },
        sku: it.sku,
        title: bundle.displayName,
        price: it.price,
        quantity: 1,
        image: bundle.thumbnail,
        properties: it.kind === 'setting' ? { metal: it.metal, size: it.ringSize } : {}
      });
    });
    saveCart();
    renderCartDrawer();
    updateCartCounts();
    openCart();
    showToast('Your ring has been added to cart');
  };

  // ---------- BUY NOW (auto-create a Shopify product for a built ring / loose diamond) ----------
  // The worker creates a one-off Shopify product at the exact price and returns its variant id,
  // which we then add to the real cart so the customer checks out instantly via Shop Pay.
  window.galloBuyNow = function (item) {
    if (!SHOPIFY) {
      cart.items.push({ lineId: crypto.randomUUID(), quantity: 1, title: item.title, price: item.price, image: item.image || 'bg-yellow', properties: item.properties || {} });
      saveCart(); renderCartDrawer(); updateCartCounts(); openCart(); showToast('Added to cart');
      return;
    }
    showToast('Reserving your selection…');
    fetch('https://gallo-diamonds.gallojewelry.workers.dev/buy', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(item)
    })
      .then(function (r) { return r.ok ? r.json() : r.json().then(function (e) { return Promise.reject(e); }); })
      .then(function (res) {
        if (!res || !res.variantId) throw new Error('No variant returned');
        return shopifyAddVariant(res.variantId, 1, item.properties || {});
      })
      .then(function () { showToast((item.title || 'Your selection') + ' added to cart'); })
      .catch(function (err) { showToast((err && (err.error || err.message)) || 'Could not start checkout — please call 973-890-7000'); });
  };

  // ---------- TOAST ----------
  window.showToast = showToast;
  function showToast(msg) {
    let toast = document.querySelector('.toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'toast';
      document.body.appendChild(toast);
    }
    toast.textContent = msg;
    toast.classList.add('show');
    clearTimeout(toast._t);
    toast._t = setTimeout(() => toast.classList.remove('show'), 2400);
  }

  // ---------- CART DRAWER ----------
  let drawerOpen = false;
  function openCart() {
    drawerOpen = true;
    document.querySelector('.cart-drawer')?.classList.add('open');
    document.querySelector('.drawer-backdrop')?.classList.add('open');
    document.body.style.overflow = 'hidden';
    renderCartDrawer();
  }
  function closeCart() {
    drawerOpen = false;
    document.querySelector('.cart-drawer')?.classList.remove('open');
    document.querySelector('.drawer-backdrop')?.classList.remove('open');
    document.body.style.overflow = '';
  }
  function toggleCart() { drawerOpen ? closeCart() : openCart(); }

  // Free shipping kicks in at $1,000 and up
  const FREE_SHIP_MIN = 1000;
  function updateShipMeter() {
    const wrap = document.querySelector('.cart-shipping');
    if (!wrap) return;
    const lbl = wrap.querySelector('.lbl');
    const fill = wrap.querySelector('.bar .fill');
    const sub = cartSubtotal();
    if (fill) fill.style.width = Math.min(100, Math.round(sub / FREE_SHIP_MIN * 100)) + '%';
    if (!lbl) return;
    const check = '<svg width="12" height="12" viewBox="0 0 12 12" fill="none" stroke="currentColor" stroke-width="2"><path d="M2 6l3 3 5-6"/></svg> ';
    if (sub >= FREE_SHIP_MIN) {
      lbl.innerHTML = check + "You've unlocked free shipping.";
    } else if (sub > 0) {
      lbl.textContent = "You're " + fmtMoney(FREE_SHIP_MIN - sub) + " away from free shipping.";
    } else {
      lbl.textContent = "Free shipping on orders $1,000 and up.";
    }
  }

  function renderCartDrawer() {
    const body = document.querySelector('.cart-body');
    const foot = document.querySelector('.cart-foot');
    const head = document.querySelector('[data-cart-count-header]');
    if (!body || !foot) return;
    head && (head.textContent = cartCount());
    updateShipMeter();

    if (cart.items.length === 0) {
      body.innerHTML = `
        <div class="empty-cart">
          <svg width="48" height="48" viewBox="0 0 48 48" fill="none" stroke="currentColor" stroke-width="1">
            <path d="M10 18 L24 6 L38 18 L24 42 Z"/>
          </svg>
          <h3 class="display-md">Your cart is empty.</h3>
          <p class="body-md">Browse engagement rings, fine jewelry, or design something custom.</p>
          <div class="links">
            <a href="${SHOPIFY ? '/collections/engagement-ring-rtw' : 'engagement.html'}" class="btn btn-secondary btn-full">Browse Engagement</a>
            <a href="${SHOPIFY ? '/collections/engagement-ring-settings' : 'customize.html'}" class="btn btn-secondary btn-full">Create Your Own</a>
            <a href="${SHOPIFY ? '/collections/all' : 'index.html#collections'}" class="btn btn-secondary btn-full">Shop All Jewelry</a>
          </div>
        </div>`;
      foot.style.display = 'none';
      return;
    }
    foot.style.display = '';

    // Group bundles
    const rows = [];
    const seenBundles = new Set();
    for (const item of cart.items) {
      if (item.bundleId) {
        if (seenBundles.has(item.bundleId)) continue;
        seenBundles.add(item.bundleId);
        const bundleItems = cart.items.filter(i => i.bundleId === item.bundleId);
        rows.push({ kind: 'bundle', bundleId: item.bundleId, items: bundleItems, displayName: item.bundleMeta.displayName, image: item.image,
          price: bundleItems.reduce((s, i) => s + i.price * i.quantity, 0) });
      } else {
        rows.push({ kind: 'single', ...item });
      }
    }

    body.innerHTML = rows.map(row => {
      if (row.kind === 'bundle') {
        const setting = row.items.find(i => i.bundleRole === 'setting');
        const diamond = row.items.find(i => i.bundleRole === 'diamond');
        return `
          <article class="line-item">
            <div class="line-img ${setting?.image || 'bg-yellow'}">${ringSvg('round')}</div>
            <div class="line-body">
              <p class="line-title">${row.displayName}</p>
              <p class="line-meta">${setting?.properties?.metal || ''} ${setting?.properties?.size ? '· Size ' + setting.properties.size : ''}</p>
              <p class="line-meta color-shadow">Includes diamond (${diamond?.sku || ''})</p>
              <a href="customize.html" class="edit-link">✏ Edit ring</a>
              <div class="line-row">
                <p class="price-tk color-noir">${fmtMoney(row.price)}</p>
                <button class="remove" data-remove-bundle="${row.bundleId}" aria-label="Remove">
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M3 4h10M6 4V2h4v2M5 4l1 10h4l1-10"/></svg>
                </button>
              </div>
            </div>
          </article>`;
      }
      const _key = row.lineKey || row.lineId;
      const _lineTotal = SHOPIFY ? row.linePrice : (row.price * row.quantity);
      const _img = row.imageUrl ? `<img src="${row.imageUrl}" alt="" style="width:100%;height:100%;object-fit:cover">` : ringSvg(row.shape || 'round');
      const _meta = SHOPIFY ? (row.variantTitle || '') : [row.properties?.metal, row.properties?.size ? 'Size ' + row.properties.size : null].filter(Boolean).join(' · ');
      const _title = row.url ? `<a href="${row.url}" style="color:inherit;text-decoration:none">${row.title}</a>` : row.title;
      return `
        <article class="line-item">
          <div class="line-img ${row.imageUrl ? '' : (row.image || 'bg-yellow')}">${_img}</div>
          <div class="line-body">
            <p class="line-title">${_title}</p>
            ${_meta ? `<p class="line-meta">${_meta}</p>` : ''}
            <div class="line-row">
              <p class="price-tk color-noir">${fmtMoney(_lineTotal)}</p>
              <div class="flex" style="align-items:center">
                <div class="qty">
                  <button data-qty-dec="${_key}" aria-label="Decrease">−</button>
                  <span class="val">${row.quantity}</span>
                  <button data-qty-inc="${_key}" aria-label="Increase">+</button>
                </div>
                <button class="remove" data-remove="${_key}" aria-label="Remove">
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M3 4h10M6 4V2h4v2M5 4l1 10h4l1-10"/></svg>
                </button>
              </div>
            </div>
          </div>
        </article>`;
    }).join('');

    const _sub = cartSubtotal();
    const _co = fmtMoney(_sub);
    const checkoutBtn = SHOPIFY
      ? `<a href="/checkout" class="btn btn-primary btn-lg btn-full button-text mt-4" style="text-align:center;display:block">Checkout — ${_co}</a>`
      : `<button class="btn btn-primary btn-lg btn-full button-text mt-4" onclick="alert('Demo site — checkout would go to Shopify hosted checkout here.')">Checkout — ${_co}</button>`;
    const financingHref = SHOPIFY ? '/pages/policies#financing' : 'policies.html#financing';
    const visitHref = SHOPIFY ? '/pages/visit#book' : 'visit.html#book';
    foot.innerHTML = `
      <dl class="cart-totals">
        <div class="row"><dt>Subtotal</dt><dd class="mono">${fmtMoney(cartSubtotal())}</dd></div>
        <div class="row"><dt>Shipping</dt><dd style="${_sub >= FREE_SHIP_MIN ? 'color:var(--accent-success)' : 'color:var(--ink-shadow);font-size:.8125rem'}">${_sub >= FREE_SHIP_MIN ? 'Free' : 'Calculated at checkout'}</dd></div>
        <div class="row"><dt>Estimated tax</dt><dd style="color:var(--ink-shadow);font-size:.8125rem">Calculated at checkout</dd></div>
        <div class="row total"><dt>Total</dt><dd>${fmtMoney(cartSubtotal())}</dd></div>
      </dl>
      <p class="body-sm color-shadow" style="margin:6px 0 0">From <strong>${'$' + Math.ceil(cartSubtotal() / 12).toLocaleString()}/mo</strong> with Shop Pay Installments · <a href="${financingHref}">Learn more</a></p>
      ${checkoutBtn}
      <a href="${visitHref}" class="btn btn-secondary btn-full button-text mt-3" style="text-align:center">Book a Showroom Visit</a>
      <button class="btn-tertiary button-text mt-3" style="width:100%;text-align:center" onclick="document.querySelector('.cart-drawer').classList.remove('open');document.querySelector('.drawer-backdrop').classList.remove('open');document.body.style.overflow=''">Continue Shopping</button>
      <ul class="cart-trust">
        <li>✓ Lifetime Warranty</li>
        <li>✓ 30-Day Returns</li>
        <li>✓ Insurance-Grade Appraisal Included</li>
      </ul>`;
  }

  // Render SVG for line-item thumb
  function ringSvg(shape) {
    const stones = {
      round: '<circle cx="40" cy="32" r="7" stroke="#1A1A1A" stroke-width="1" fill="rgba(255,255,255,0.8)"/>',
      oval:  '<ellipse cx="40" cy="32" rx="6" ry="9" stroke="#1A1A1A" stroke-width="1" fill="rgba(255,255,255,0.8)"/>',
      emerald: '<rect x="33" y="24" width="14" height="16" stroke="#1A1A1A" stroke-width="1" fill="rgba(255,255,255,0.8)"/>',
      pear: '<path d="M40 22 Q33 36 40 44 Q47 36 40 22 Z" stroke="#1A1A1A" stroke-width="1" fill="rgba(255,255,255,0.8)"/>',
    };
    return `<svg viewBox="0 0 80 80">
      <ellipse cx="40" cy="52" rx="20" ry="7" stroke="#1A1A1A" stroke-width="1" fill="none"/>
      <path d="M20 52 L26 72 L54 72 L60 52" stroke="#1A1A1A" stroke-width="1" fill="none"/>
      ${stones[shape] || stones.round}
    </svg>`;
  }

  // ---------- DRAWER EVENT WIRING ----------
  document.addEventListener('click', (e) => {
    const trig = e.target.closest('[data-cart-toggle]');
    if (trig) { e.preventDefault(); if (SHOPIFY) { drawerOpen ? closeCart() : refreshCart(true); } else { toggleCart(); } return; }
    const close = e.target.closest('[data-cart-close]');
    if (close) { e.preventDefault(); closeCart(); return; }
    if (e.target.classList.contains('drawer-backdrop')) closeCart();

    const inc = e.target.closest('[data-qty-inc]');
    if (inc) {
      const it = cart.items.find(i => (i.lineKey || i.lineId) === inc.dataset.qtyInc);
      if (it) {
        if (SHOPIFY) shopifyChangeLine(it.lineKey, it.quantity + 1);
        else { it.quantity++; saveCart(); renderCartDrawer(); updateCartCounts(); }
      }
      return;
    }
    const dec = e.target.closest('[data-qty-dec]');
    if (dec) {
      const it = cart.items.find(i => (i.lineKey || i.lineId) === dec.dataset.qtyDec);
      if (it) {
        if (SHOPIFY) shopifyChangeLine(it.lineKey, Math.max(0, it.quantity - 1));
        else if (it.quantity > 1) { it.quantity--; saveCart(); renderCartDrawer(); updateCartCounts(); }
      }
      return;
    }
    const rm = e.target.closest('[data-remove]');
    if (rm) {
      if (SHOPIFY) {
        const it = cart.items.find(i => i.lineKey === rm.dataset.remove);
        if (it) shopifyChangeLine(it.lineKey, 0);
      } else {
        cart.items = cart.items.filter(i => i.lineId !== rm.dataset.remove);
        saveCart(); renderCartDrawer(); updateCartCounts();
      }
      return;
    }
    const rmB = e.target.closest('[data-remove-bundle]');
    if (rmB) {
      cart.items = cart.items.filter(i => i.bundleId !== rmB.dataset.removeBundle);
      saveCart(); renderCartDrawer(); updateCartCounts();
    }
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && drawerOpen) closeCart(); });

  // Sync the drawer with Shopify's live cart on load
  if (SHOPIFY) refreshCart(false);

  // ---------- SEARCH OVERLAY ----------
  const RESULTS = {
    'donatella': {
      collections: [{ title: 'Donatella Collection', href: 'engagement.html', count: 12 }],
      products: [
        { title: 'The Donatella · Hidden Halo Engagement Ring', price: 1890, href: 'product.html', bg: 'bg-yellow', shape: 'round' },
        { title: 'Donatella Studs', price: 890, href: '#', bg: 'bg-yellow', shape: 'round' },
        { title: 'Donatella Pendant Necklace', price: 1420, href: '#', bg: 'bg-rose', shape: 'round' }
      ],
      editorial: [{ title: 'The Donatella Story: Inside Our New York Atelier', kind: 'Story', href: 'about.html' }]
    },
    'toi': {
      collections: [{ title: 'Toi et Moi Collection', href: 'engagement.html', count: 8 }],
      products: [{ title: 'Toi et Moi', price: 2210, href: '#', bg: 'bg-yellow-2', shape: 'pear' }],
      editorial: []
    }
  };
  const POPULAR = ['Donatella', 'Toi et Moi', '1.5 ct round', 'Pavé', 'Vintage', 'Hidden halo', 'Pear shape', 'Tennis bracelet'];

  function openSearch() {
    const ov = document.querySelector('.search-overlay');
    if (!ov) return;
    ov.classList.add('open');
    document.body.style.overflow = 'hidden';
    setTimeout(() => ov.querySelector('input')?.focus(), 50);
    renderSearchEmpty();
  }
  function closeSearch() {
    const ov = document.querySelector('.search-overlay');
    if (!ov) return;
    ov.classList.remove('open');
    document.body.style.overflow = '';
  }
  function renderSearchEmpty() {
    const out = document.querySelector('[data-search-results]');
    if (!out) return;
    out.innerHTML = `
      <div class="chip-row">
        <p class="chip-row-label">Popular</p>
        <div class="chip-row-items">
          ${POPULAR.map(c => `<button class="chip-pill" data-search-pick="${c}">${c}</button>`).join('')}
        </div>
      </div>`;
  }
  async function shopifySearch(q, out) {
    const url = '/search/suggest.json?q=' + encodeURIComponent(q)
      + '&resources[type]=product,collection,page,article&resources[limit]=6'
      + '&resources[options][unavailable_products]=last';
    const res = await fetch(url, { headers: { 'Accept': 'application/json' } });
    const R = (((await res.json()) || {}).resources || {}).results || {};
    const products = R.products || [], collections = R.collections || [], pages = R.pages || [], articles = R.articles || [];
    const esc = s => (s || '').replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
    const money = v => { const n = parseFloat(v); return isFinite(n) ? '$' + n.toLocaleString('en-US', { maximumFractionDigits: 0 }) : ''; };
    if (!products.length && !collections.length && !pages.length && !articles.length) {
      out.innerHTML = '<div class="center" style="padding:64px 0"><p class="eyebrow">No matches</p><p class="display-sm color-noir mt-3">Nothing for "' + esc(q) + '"</p><p class="body-md color-shadow mt-3">Try a style, stone shape, or carat weight.</p></div>';
      return;
    }
    out.innerHTML =
      (products.length ? '<div class="result-group"><h4>Products (' + products.length + ')</h4><ul>' + products.map(p => '<li><a href="' + p.url + '" class="result-product"><div class="thumb">' + (p.image ? '<img src="' + p.image + '" alt="" style="width:100%;height:100%;object-fit:cover">' : '') + '</div><span class="title">' + esc(p.title) + '</span><span class="price price-tk">' + money(p.price) + '</span></a></li>').join('') + '</ul></div>' : '')
      + (collections.length ? '<div class="result-group"><h4>Collections (' + collections.length + ')</h4><ul>' + collections.map(c => '<li><a href="' + c.url + '" class="result-product"><span class="title">→ ' + esc(c.title) + '</span></a></li>').join('') + '</ul></div>' : '')
      + ((pages.length || articles.length) ? '<div class="result-group"><h4>Guides &amp; pages</h4><ul>' + pages.concat(articles).map(e => '<li><a href="' + e.url + '" class="result-product"><span class="title">→ ' + esc(e.title) + '</span></a></li>').join('') + '</ul></div>' : '');
  }
  async function searchFor(q) {
    const out = document.querySelector('[data-search-results]');
    if (!out) return;
    if (!q.trim()) { renderSearchEmpty(); return; }
    if (window.GALLO_URL && window.GALLO_URL.shopify) { try { return await shopifySearch(q.trim(), out); } catch (e) {} }
    q = q.trim().toLowerCase();
    let r = null;
    for (const key of Object.keys(RESULTS)) {
      if (q.includes(key) || key.includes(q)) { r = RESULTS[key]; break; }
    }
    if (!r) {
      // Keyword router: send real queries to the right page instead of a dead end.
      const SHAPES = ['round','oval','princess','emerald','pear','marquise','cushion','asscher','radiant','heart'];
      const routes = [];
      const shape = SHAPES.find(s => q.includes(s));
      if (shape) routes.push({ title: `${shape[0].toUpperCase() + shape.slice(1)} lab diamonds`, href: `diamonds.html?shape=${shape[0].toUpperCase() + shape.slice(1)}` });
      const PAGE_ROUTES = [
        [/diamond|lab.?grown|stone|carat|loose/, 'Lab-Grown Diamonds', 'diamonds.html'],
        [/engage|solitaire|halo|proposal/, 'Engagement Rings', 'engagement.html'],
        [/wedding|band/, 'Wedding & Bands', 'wedding.html'],
        [/tennis/, 'Tennis Bracelets', 'tennis-bracelets.html'],
        [/bracelet/, 'Bracelets', 'bracelets.html'],
        [/necklace|pendant|chain/, 'Necklaces', 'necklaces.html'],
        [/earring|stud/, 'Earrings', 'earrings.html'],
        [/\bring/, 'Rings', 'rings.html'],
        [/watch|seiko|bulova/, 'Watches', 'watches.html'],
        [/gem|sapphire|ruby|birthstone/, 'Gemstones', 'gemstones.html'],
        [/\bmen/, "Men's Jewelry", 'mens-jewelry.html'],
        [/educat|4c|learn|guide/, 'Diamond Education', 'education.html'],
        [/visit|appointment|consult|showroom/, 'Visit the Showroom', 'visit.html'],
        [/repair|service|battery|sizing/, 'In-House Services', 'watches.html#service'],
        [/custom|design|build/, 'Design Your Own Ring', 'customize.html'],
      ];
      PAGE_ROUTES.forEach(([re2, title, href]) => { if (re2.test(q)) routes.push({ title, href }); });
      if (routes.length) {
        out.innerHTML = `<div class="result-group">
          <h4>Where to find it</h4>
          <ul>${routes.slice(0, 5).map(c => `<li><a href="${c.href}" class="result-product"><span class="title">→ ${c.title}</span></a></li>`).join('')}</ul>
        </div>`;
        return;
      }
      const safeQ = q.replace(/[&<>"']/g, c => ({ '&':'&amp;', '<':'&lt;', '>':'&gt;', '"':'&quot;', "'":'&#39;' }[c]));
      out.innerHTML = `<div class="center" style="padding:64px 0">
        <p class="eyebrow">No matches</p>
        <p class="display-sm color-noir mt-3">We couldn't find anything for "${safeQ}"</p>
        <p class="body-md color-shadow mt-3">Try searching by style, stone shape, or carat weight.</p>
      </div>`;
      return;
    }
    out.innerHTML = `
      ${r.collections.length ? `<div class="result-group">
        <h4>Collections (${r.collections.length})</h4>
        <ul>${r.collections.map(c => `<li><a href="${c.href}" class="result-product"><span class="title">→ ${c.title} <span class="color-shadow">(${c.count} styles)</span></span></a></li>`).join('')}</ul>
      </div>` : ''}
      ${r.products.length ? `<div class="result-group">
        <h4>Products (${r.products.length})</h4>
        <ul>${r.products.map(p => `<li><a href="${p.href}" class="result-product">
          <div class="thumb ${p.bg}">${ringSvg(p.shape)}</div>
          <span class="title">${p.title}</span>
          <span class="price price-tk">${fmtMoney(p.price)}</span>
        </a></li>`).join('')}</ul>
      </div>` : ''}
      ${r.editorial.length ? `<div class="result-group">
        <h4>Editorial (${r.editorial.length})</h4>
        <ul>${r.editorial.map(e => `<li><a href="${e.href}" class="result-product" style="display:block;padding:14px 16px">
          <span class="eyebrow color-shadow">${e.kind}</span>
          <span class="title" style="display:block;margin-top:4px">→ ${e.title}</span>
        </a></li>`).join('')}</ul>
      </div>` : ''}`;
  }
  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-search-trigger]')) { e.preventDefault(); openSearch(); }
    if (e.target.closest('[data-search-close]')) { e.preventDefault(); closeSearch(); }
    const pick = e.target.closest('[data-search-pick]');
    if (pick) {
      const input = document.querySelector('[data-search-input]');
      if (input) { input.value = pick.dataset.searchPick; searchFor(input.value); }
    }
  });
  document.addEventListener('keydown', (e) => {
    if ((e.metaKey || e.ctrlKey) && e.key === 'k') { e.preventDefault(); openSearch(); }
    if (e.key === 'Escape' && document.querySelector('.search-overlay.open')) closeSearch();
  });
  document.addEventListener('input', (e) => {
    if (e.target.matches('[data-search-input]')) {
      clearTimeout(window._searchT);
      window._searchT = setTimeout(() => searchFor(e.target.value), 180);
    }
  });

  // ---------- MEGA MENU (hover + keyboard, per-category panel swap) ----------
  let megaTimer = null;
  const megaMenu = document.querySelector('.mega-menu');

  // One-time setup: ARIA wiring, panel ids, "Shop all" links, featured links.
  // Done in JS so all 46 pages get it without touching duplicated markup.
  (function setupMega() {
    if (!megaMenu) return;
    const trigs = document.querySelectorAll('[data-mega]');
    trigs.forEach(t => {
      const cat = t.getAttribute('data-mega');
      const panel = megaMenu.querySelector(`[data-panel="${cat}"]`);
      if (!panel) return;
      if (!panel.id) panel.id = 'mega-panel-' + cat;
      t.setAttribute('aria-haspopup', 'true');
      t.setAttribute('aria-expanded', 'false');
      t.setAttribute('aria-controls', panel.id);
      panel.setAttribute('role', 'region');
      panel.setAttribute('aria-label', (t.textContent || cat).trim());

      // Inject a "Shop all X →" link at the foot of the panel's inner grid.
      const inner = panel.querySelector('.mega-inner') || panel;
      if (inner && !inner.querySelector('.mega-shopall')) {
        const a = document.createElement('a');
        a.className = 'mega-shopall';
        a.href = t.getAttribute('href') || (cat + '.html');
        a.innerHTML = 'Shop all ' + (t.textContent || cat).trim() + ' <span aria-hidden="true">→</span>';
        inner.appendChild(a);
      }
    });

    // ----- Real Gallo icons from the live theme sprite (matches the website) -----
    // Each entry is the background-position into tps-header-footer-sprite.svg.
    const SP = {
      // ring styles
      solitaire:'-9px -96px', halo:'-122px -96px', 'hidden halo':'-289px -332px', 'three stone':'-231px -96px',
      'side stone':'-173px -96px', vintage:'-64px -97px', statement:'-223px -334px', classic:'-8px -297px',
      modern:'-223px -297px', nature:'-356px -297px',
      // shapes
      round:'-11px -148px', cushion:'-96px -148px', princess:'-52px -148px', asscher:'-140px -148px',
      oval:'-220px -148px', radiant:'-375px -148px', pear:'-258px -148px', marquise:'-183px -148px',
      'emerald-shape':'-298px -148px', heart:'-334px -148px',
      // ring types
      anniversary:'-11px -452px', cocktail:'-62px -452px', 'fashion ring':'-117px -452px', stackable:'-171px -451px',
      'wedding ring':'-227px -452px', 'cluster ring':'-290px -452px', eternity:'-346px -452px', 'vintage ring':'-406px -451px',
      // earrings
      stud:'-12px -484px', hoop:'-65px -484px', drop:'-120px -483px', 'cluster earring':'-163px -483px', 'fashion earring':'-217px -484px',
      // necklaces / pendants
      'tennis necklace':'-13px -520px', yard:'-53px -521px', 'cluster pendant':'-97px -521px', religious:'-134px -524px',
      'solitaire pendant':'-168px -524px', 'fashion pendant':'-202px -524px', necklace:'-11px -520px', initials:'-230px -519px',
      // bracelets
      'tennis bracelet':'-9px -556px', bangle:'-63px -556px', charm:'-116px -556px', bracelet:'-168px -556px', cuff:'-223px -557px', mens:'-278px -556px',
      // colored gemstones
      moissanite:'-19px -20px', sapphire:'-58px -20px', aquamarine:'-146px -20px', alexandrite:'-184px -20px',
      morganite:'-226px -20px', ruby:'-272px -20px', garnet:'-316px -20px', topaz:'-359px -20px', tanzanite:'-400px -20px',
      tourmaline:'-445px -20px', amethyst:'-488px -20px', spinel:'-576px -20px', peridot:'-619px -20px', citrine:'-659px -20px', gem:'-704px -20px',
    };
    function spritePos(text) {
      const s = (text || '').toLowerCase().replace(/&amp;/g, '&').trim();
      // colored gemstones — separate PNG sprite (tps-gemstone-menu-sprite.png), prefixed "gem|"
      const GEM = {
        moissanite:'-19px -20px', sapphire:'-58px -20px', emerald:'-100px -20px', aquamarine:'-146px -20px',
        alexandrite:'-184px -20px', morganite:'-226px -20px', ruby:'-272px -20px', garnet:'-316px -20px',
        topaz:'-359px -20px', tanzanite:'-400px -20px', tourmaline:'-445px -20px', amethyst:'-488px -20px',
        spinel:'-576px -20px', peridot:'-619px -20px', citrine:'-659px -20px', other:'-704px -20px',
      };
      if (/pink sapphire/.test(s)) return 'gem|' + GEM.morganite;   // pink
      if (/yellow sapphire/.test(s)) return 'gem|' + GEM.citrine;   // yellow
      if (/padparadscha/.test(s)) return 'gem|' + GEM.morganite;    // pink-orange
      if (/sapphire/.test(s)) return 'gem|' + GEM.sapphire;         // blue
      if (/ruby/.test(s)) return 'gem|' + GEM.ruby;
      if (/emerald/.test(s)) return 'gem|' + GEM.emerald;
      if (/morganite/.test(s)) return 'gem|' + GEM.morganite;
      if (/aquamarine/.test(s)) return 'gem|' + GEM.aquamarine;
      if (/tanzanite/.test(s)) return 'gem|' + GEM.tanzanite;
      if (/tourmaline/.test(s)) return 'gem|' + GEM.tourmaline;
      if (/amethyst/.test(s)) return 'gem|' + GEM.amethyst;
      if (/garnet/.test(s)) return 'gem|' + GEM.garnet;
      if (/topaz/.test(s)) return 'gem|' + GEM.topaz;
      if (/citrine/.test(s)) return 'gem|' + GEM.citrine;
      if (/peridot/.test(s)) return 'gem|' + GEM.peridot;
      if (/spinel/.test(s)) return 'gem|' + GEM.spinel;
      if (/alexandrite/.test(s)) return 'gem|' + GEM.alexandrite;
      if (/moissanite/.test(s)) return 'gem|' + GEM.moissanite;
      if (/all gemstone|opal|gemstone/.test(s)) return 'gem|' + GEM.other;
      // earrings
      if (/stud|east-west|halo stud/.test(s)) return SP.stud;
      if (/hoop/.test(s)) return SP.hoop;
      if (/drop|dangle|climber|earring/.test(s)) return SP.drop;
      // necklaces / pendants
      if (/tennis necklace|diamond tennis/.test(s)) return SP['tennis necklace'];
      if (/yard/.test(s)) return SP.yard;
      if (/solitaire pendant/.test(s)) return SP['solitaire pendant'];
      if (/religious/.test(s)) return SP.religious;
      if (/layering|chain/.test(s)) return SP.necklace;
      if (/pendant/.test(s)) return SP['cluster pendant'];
      if (/necklace/.test(s)) return SP.necklace;
      // bracelets
      if (/tennis bracelet/.test(s)) return SP['tennis bracelet'];
      if (/bangle/.test(s)) return SP.bangle;
      if (/charm/.test(s)) return SP.charm;
      if (/cuff/.test(s)) return SP.cuff;
      if (/bracelet/.test(s)) return SP.bracelet;
      // ring styles / types
      if (/hidden halo/.test(s)) return SP['hidden halo'];
      if (/halo/.test(s)) return SP.halo;
      if (/solitaire/.test(s)) return SP.solitaire;
      if (/three stone|toi et moi/.test(s)) return SP['three stone'];
      if (/side stone/.test(s)) return SP['side stone'];
      if (/eternity/.test(s)) return SP.eternity;
      if (/anniversary/.test(s)) return SP.anniversary;
      if (/cocktail/.test(s)) return SP.cocktail;
      if (/stackable/.test(s)) return SP.stackable;
      if (/cluster/.test(s)) return SP['cluster ring'];
      if (/nature/.test(s)) return SP.nature;
      if (/statement/.test(s)) return SP.statement;
      if (/modern/.test(s)) return SP.modern;
      if (/fashion ring/.test(s)) return SP['fashion ring'];
      // wedding-band styles & metals → wedding-ring icon
      if (/pav|inset|hammer|bevel|textur|two-tone|comfort|plain|curved|contour|tungsten|black|14k|18k|gold|platinum|wedding/.test(s)) return SP['wedding ring'];
      if (/classic/.test(s)) return SP.classic;
      if (/vintage/.test(s)) return SP.vintage;
      // diamonds panel (build / education) → round diamond icon
      if (/ringbuilder|build|lab|stone|4c|guide|certif|gia|igi|faq|natural|diamond|carat|loose/.test(s)) return SP.round;
      if (/ring/.test(s)) return SP['fashion ring'];
      return null;  // no good match (e.g. watches) → no icon, like the live site
    }
    // Wedding bands have their OWN icon row in the sprite (flat bands) — never use
    // the engagement-ring icons here.
    function weddingPos(text) {
      const s = (text || '').toLowerCase().replace(/&amp;/g, '&');
      if (/eternity/.test(s)) return '-70px -377px';
      if (/anniversary/.test(s)) return '-129px -377px';
      if (/stackable/.test(s)) return '-78px -297px';
      if (/curved|contour/.test(s)) return '-186px -377px';
      if (/vintage/.test(s)) return '-244px -377px';
      if (/pav|inset|diamond/.test(s)) return '-10px -407px';
      if (/textur|hammer|bevel/.test(s)) return '-129px -408px';
      if (/two-tone|tungsten|black|alternative/.test(s)) return '-187px -408px';
      if (/plain/.test(s)) return '-304px -376px';
      if (/14k|18k|gold|platinum|metal/.test(s)) return '-304px -376px';
      if (/comfort|classic/.test(s)) return '-9px -377px';
      return '-9px -377px';   // default: classic band
    }
    megaMenu.querySelectorAll('.mega-col li a').forEach(a => {
      a.querySelector('.mega-licon')?.remove();
      const cat = a.closest('.mega-panel')?.getAttribute('data-panel');
      if (cat === 'watches') return;                 // watches: no icons, ever
      let pos = cat === 'wedding' ? weddingPos(a.textContent || '') : spritePos(a.textContent || '');
      if (!pos) return;
      const isGem = pos.indexOf('gem|') === 0;
      if (isGem) pos = pos.slice(4);
      const span = document.createElement('span');
      span.className = 'mega-licon' + (isGem ? ' mega-licon--gem' : '');
      span.style.backgroundPosition = pos;
      a.insertAdjacentElement('afterbegin', span);
    });

    // ----- Category-matched featured image (fixes mismatches, e.g. engagement showing a watch) -----
    const FEATURE = {
      engagement: { img:'assets/img/cf/3101e83fc8-1600.webp', eyebrow:'Featured', title:'Halo Engagement Rings' },
      wedding:    { img:'assets/img/cf/83165cad99-1600.webp', eyebrow:'Featured', title:'Wedding Bands' },
      jewelry:    { img:'assets/img/cf/16f7b281bb-1600.webp', eyebrow:'Featured', title:'Diamond Necklaces' },
      diamonds:   { img:'assets/img/cf/dbb8c3a92c-1600.webp', eyebrow:'Featured', title:'Certified Loose Diamonds' },
      gemstones:  { img:'assets/img/cf/6602e79b6b-1600.webp', eyebrow:'Featured', title:'Colored Gemstones' },
    };
    Object.entries(FEATURE).forEach(([cat, f]) => {
      const panel = megaMenu.querySelector(`[data-panel="${cat}"]`);
      const fig = panel && panel.querySelector('.mega-feature');
      if (!fig) return;
      const img = fig.querySelector('img');
      // Skip when the markup already supplies an absolute image (e.g. the Shopify
      // theme's cdn.shopify.com URLs). Only fill in the static site's relative/empty
      // srcs, so this no longer overwrites good images with 404 static paths off-site.
      if (img && /^https?:\/\//i.test(img.getAttribute('src') || '')) return;
      if (img) { img.src = f.img; img.removeAttribute('srcset'); img.alt = f.title; }
      const h5 = fig.querySelector('h5'); if (h5) h5.textContent = f.title;
      const eyebrow = fig.querySelector('.eyebrow'); if (eyebrow) eyebrow.textContent = f.eyebrow;
    });
  })();

  function openMega(category) {
    if (!megaMenu) return;
    const panel = megaMenu.querySelector(`[data-panel="${category}"]`);
    clearTimeout(megaTimer);
    if (!panel) { closeMega(); return; }
    megaMenu.setAttribute('data-active', category);
    megaTimer = setTimeout(() => megaMenu.classList.add('open'), 120);
    document.querySelectorAll('[data-mega]').forEach(t => {
      const on = t.getAttribute('data-mega') === category;
      t.classList.toggle('mega-active', on);
      t.setAttribute('aria-expanded', on ? 'true' : 'false');
    });
  }
  function closeMega() {
    if (!megaMenu) return;
    megaMenu.classList.remove('open');
    megaMenu.setAttribute('data-active', '');
    document.querySelectorAll('[data-mega]').forEach(t => {
      t.classList.remove('mega-active');
      t.setAttribute('aria-expanded', 'false');
    });
  }

  // --- Hover (unchanged behavior, now routed through open/closeMega) ---
  document.addEventListener('mouseover', (e) => {
    const trig = e.target.closest('[data-mega]');
    if (trig) openMega(trig.getAttribute('data-mega'));
  });
  document.addEventListener('mouseout', (e) => {
    const fromTrig = e.target.closest('[data-mega]');
    const toEl = e.relatedTarget;
    if (!megaMenu || !fromTrig) return;
    if (toEl && (toEl.closest('.mega-menu') || toEl.closest('[data-mega]'))) return;
    clearTimeout(megaTimer);
    megaTimer = setTimeout(closeMega, 200);
  });
  megaMenu?.addEventListener('mouseleave', () => {
    clearTimeout(megaTimer);
    megaTimer = setTimeout(closeMega, 200);
  });
  megaMenu?.addEventListener('mouseenter', () => clearTimeout(megaTimer));

  // --- Keyboard + screen-reader access ---
  document.querySelectorAll('[data-mega]').forEach(trig => {
    // Down arrow opens the panel and moves focus into it; the link's own
    // Enter/click still navigates to the category page.
    trig.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowDown') {
        e.preventDefault();
        openMega(trig.getAttribute('data-mega'));
        const panel = megaMenu?.querySelector(`[data-panel="${trig.getAttribute('data-mega')}"]`);
        panel?.querySelector('a')?.focus();
      } else if (e.key === 'Escape') {
        closeMega();
      }
    });
    // Focusing a trigger by keyboard previews its panel.
    trig.addEventListener('focus', () => openMega(trig.getAttribute('data-mega')));
  });
  // Escape anywhere inside the menu closes it and returns focus to the trigger.
  megaMenu?.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      const active = megaMenu.getAttribute('data-active');
      closeMega();
      document.querySelector(`[data-mega="${active}"]`)?.focus();
    }
  });
  // Tabbing completely out of the nav closes the menu.
  document.addEventListener('focusout', () => {
    setTimeout(() => {
      const el = document.activeElement;
      if (el && (el.closest('.mega-menu') || el.closest('[data-mega]'))) return;
      closeMega();
    }, 0);
  });

  // ---------- ACCORDION-FREE GENERIC DETAILS BEHAVIOR ----------
  // (Built into <details> natively; nothing to wire)

  // ---------- METAL SWATCH SELECTION (PDP) ----------
  document.addEventListener('click', (e) => {
    const sw = e.target.closest('.metal-swatch');
    if (sw) {
      sw.parentElement.querySelectorAll('.metal-swatch').forEach(s => s.classList.remove('selected'));
      sw.classList.add('selected');
      const label = sw.parentElement.parentElement.querySelector('.metal-name');
      if (label) label.textContent = sw.getAttribute('aria-label');
    }
    const pill = e.target.closest('.shape-pill');
    if (pill && !pill.disabled) {
      pill.parentElement.querySelectorAll('.shape-pill').forEach(p => p.classList.remove('selected'));
      pill.classList.add('selected');
    }
  });

  // ---------- WISHLIST ICON (visual only) ----------
  document.addEventListener('click', (e) => {
    const wl = e.target.closest('.pcard-wishlist');
    if (wl) {
      e.preventDefault();
      e.stopPropagation();
      wl.style.color = wl.style.color === 'rgb(184, 153, 104)' ? '' : '#B89968';
      showToast(wl.style.color ? 'Added to wishlist' : 'Removed from wishlist');
    }
  });

  // ---------- VISIT PAGE: calendar generator + time slots ----------
  function generateCalendar() {
    const cal = document.querySelector('[data-calendar]');
    if (!cal) return;
    const today = new Date();
    let html = '';
    for (let i = 0; i < 14; i++) {
      const d = new Date(today);
      d.setDate(today.getDate() + i);
      const dow = d.toLocaleDateString('en', { weekday: 'short' });
      const num = d.getDate();
      const isMon = d.getDay() === 1;
      const isToday = i === 0;
      const cls = ['day-cell'];
      if (isMon) cls.push('disabled');
      if (isToday) cls.push('today');
      const disabled = isMon ? 'disabled' : '';
      html += `<button type="button" class="${cls.join(' ')}" ${disabled} data-date="${d.toISOString().slice(0,10)}">
        <span class="dow">${dow}</span><span class="num">${num}</span>
      </button>`;
    }
    cal.innerHTML = html;
  }
  generateCalendar();
  document.addEventListener('click', (e) => {
    const cell = e.target.closest('[data-date]');
    if (cell && !cell.classList.contains('disabled')) {
      cell.parentElement.querySelectorAll('.day-cell').forEach(c => c.classList.remove('selected'));
      cell.classList.add('selected');
      document.querySelector('[data-time-slots]')?.classList.remove('hidden');
    }
    const pill = e.target.closest('.time-pill');
    if (pill) {
      pill.parentElement.querySelectorAll('.time-pill').forEach(p => p.classList.remove('selected'));
      pill.classList.add('selected');
    }
    const vt = e.target.closest('.visit-type-card');
    if (vt) {
      vt.parentElement.querySelectorAll('.visit-type-card').forEach(c => c.classList.remove('selected'));
      vt.classList.add('selected');
    }
  });

  // ---------- CUSTOMIZER STATE ----------
  const CUSTOMIZER_KEY = 'gallo.customizer.v1';
  function loadCustomizer() {
    try { return JSON.parse(sessionStorage.getItem(CUSTOMIZER_KEY)) || { step: 1, setting: null, diamond: null, metal: null, ringSize: null }; }
    catch (e) { return { step: 1, setting: null, diamond: null, metal: null, ringSize: null }; }
  }
  function saveCustomizer(state) {
    try { sessionStorage.setItem(CUSTOMIZER_KEY, JSON.stringify(state)); } catch (e) {}
  }
  window.galloCustomizer = {
    get state() { return loadCustomizer(); },
    selectSetting(setting, metal, shape) {
      const s = loadCustomizer();
      s.setting = setting;
      s.metal = metal || s.metal;
      // Diamond already chosen (picked stone-first) → review; otherwise → find a stone.
      s.step = s.diamond ? 3 : 2;
      saveCustomizer(s);
      // a chosen center-stone shape pre-filters the diamond search (?shape= deep link)
      window.location.href = window.GALLO_URL.customize + '?step=' + s.step + (shape && s.step === 2 ? '&shape=' + encodeURIComponent(shape) : '');
    },
    selectDiamond(diamond) {
      const s = loadCustomizer();
      s.diamond = diamond;
      // Setting already chosen → review the pair; otherwise → choose a setting next.
      s.step = s.setting ? 3 : 1;
      saveCustomizer(s);
      if (document.querySelector('[data-customizer-stepper]')) {
        renderCustomizer();                                    // already on the builder
      } else {
        window.location.href = window.GALLO_URL.customize + '?step=' + s.step; // e.g. from diamonds.html
      }
    },
    setRingSize(size) {
      const s = loadCustomizer();
      s.ringSize = size;
      saveCustomizer(s);
    },
    goToStep(n) {
      const s = loadCustomizer();
      // Allow step 2 (diamond search) even without a setting — user may want to pick stone first
      if (n === 3 && (!s.setting || !s.diamond)) return;
      s.step = n;
      saveCustomizer(s);
      renderCustomizer();
    },
    reset() {
      sessionStorage.removeItem(CUSTOMIZER_KEY);
      window.location.href = window.GALLO_URL.customize;
    },
    addToCart() {
      const s = loadCustomizer();
      if (!s.setting || !s.diamond || !s.ringSize) return;
      const displayName = `${s.setting.name} + ${s.diamond.carat}ct ${s.diamond.shape}`;
      const totalPrice = s.setting.price + s.diamond.price;
      if (window.GALLO_URL && window.GALLO_URL.shopify) {
        const metalName = (window.GALLO_METAL_NAMES && window.GALLO_METAL_NAMES[s.metal]) || s.metal;
        const diaSpec = [s.diamond.carat ? s.diamond.carat + 'ct' : '', s.diamond.shape, s.diamond.color, s.diamond.clarity].filter(Boolean).join(' ');
        window.galloBuyNow({
          title: displayName,
          image: s.setting.img || s.setting.image || '',
          kind: 'ring',
          setting: { sku: s.setting.sku },
          diamond: { id: s.diamond.id, price: s.diamond.price, q: s.diamond.q },
          properties: {
            'Setting': s.setting.name,
            'Metal': metalName,
            'Ring Size': s.ringSize,
            'Center Diamond': diaSpec,
            'Diamond Certificate': s.diamond.cert || s.diamond.certNumber || s.diamond.report || s.diamond.sku || ''
          }
        });
      } else {
        window.galloAddBundleToCart({
          bundleId: crypto.randomUUID(),
          displayName: displayName,
          totalPrice: totalPrice,
          thumbnail: s.setting.bg || 'bg-yellow',
          items: [
            { kind: 'setting', sku: s.setting.sku, metal: s.metal, ringSize: s.ringSize, price: s.setting.price },
            { kind: 'diamond', sku: s.diamond.sku, price: s.diamond.price }
          ]
        });
      }
      sessionStorage.removeItem(CUSTOMIZER_KEY);
      renderCustomizer();                       // fresh builder, no stale review panel
      window.showToast?.('Your ring is in the cart');
    }
  };

  function renderCustomizer() {
    const s = loadCustomizer();
    // Step indicator
    const stepEl = document.querySelector('[data-customizer-stepper]');
    if (stepEl) {
      stepEl.innerHTML = `
        <ol>
          <li>
            <button type="button" class="step-cell ${s.step === 1 ? 'active' : ''}" onclick="galloCustomizer.goToStep(1)">
              <div class="head">
                <span class="step-circle ${s.step > 1 ? 'completed' : (s.step === 1 ? 'active' : 'pending')}">${s.step > 1 ? '✓' : '1'}</span>
                <span class="step-label">Step 1 · Setting</span>
              </div>
              <p class="step-value ${!s.setting ? 'muted' : ''}">${s.setting?.name || 'Choose a setting'}</p>
              <p class="step-price">${s.setting ? fmtMoney(s.setting.price) : '—'}</p>
            </button>
          </li>
          <li>
            <button type="button" class="step-cell ${s.step === 2 ? 'active' : ''} ${!s.setting ? 'disabled' : ''}" onclick="galloCustomizer.goToStep(2)" ${!s.setting ? 'disabled' : ''}>
              <div class="head">
                <span class="step-circle ${s.step > 2 ? 'completed' : (s.step === 2 ? 'active' : 'pending')}">${s.step > 2 ? '✓' : '2'}</span>
                <span class="step-label ${!s.setting ? 'muted' : ''}">Step 2 · Diamond</span>
              </div>
              <p class="step-value ${!s.diamond ? 'muted' : ''}">${s.diamond ? `${s.diamond.carat}ct ${s.diamond.shape}` : 'Choose a diamond'}</p>
              <p class="step-price">${s.diamond ? fmtMoney(s.diamond.price) : '—'}</p>
            </button>
          </li>
          <li>
            <button type="button" class="step-cell ${s.step === 3 ? 'active' : ''} ${!s.diamond ? 'disabled' : ''}" onclick="galloCustomizer.goToStep(3)" ${!s.diamond ? 'disabled' : ''}>
              <div class="head">
                <span class="step-circle ${s.step === 3 ? 'active' : 'pending'}">3</span>
                <span class="step-label ${!s.diamond ? 'muted' : ''}">Step 3 · Complete</span>
              </div>
              <p class="step-value ${!s.diamond ? 'muted' : ''}">Review your ring</p>
              <p class="step-price">${(s.setting && s.diamond) ? fmtMoney(s.setting.price + s.diamond.price) : '—'}</p>
            </button>
          </li>
        </ol>
        <div class="step-rail"><div class="fill" style="width:${(s.step - 1) * 50}%"></div></div>
      `;
    }

    // Show only active step content
    document.querySelectorAll('[data-step]').forEach(el => {
      el.style.display = (parseInt(el.dataset.step) === s.step) ? '' : 'none';
    });

    // Render review (step 3)
    if (s.step === 3) renderReviewPanel(s);
  }


  function renderReviewPanel(s) {
    const panel = document.querySelector('[data-review-panel]');
    if (!panel || !s.setting || !s.diamond) return;
    const total = s.setting.price + s.diamond.price;
    const cdnBase = window.GALLO_CDN || '';
    const setImg = s.setting.img ? cdnBase + s.setting.img + (String(s.setting.img).includes('?') ? '&' : '?') + 'width=500' : '';
    panel.innerHTML = `
      <div class="ring-reveal">
        <figure><img src="${setImg}" alt="${s.setting.name}" onerror="this.parentElement.style.display='none'"><figcaption>Your setting</figcaption></figure>
        <span class="rr-plus">+</span>
        <figure><img src="${s.diamond.image || ''}" alt="Your diamond" onerror="this.parentElement.style.display='none'"><figcaption>Your stone</figcaption></figure>
      </div>
      <p class="body-sm color-shadow" style="text-align:center;margin:2px 0 16px">We'll send free CAD previews of the finished ring before crafting begins.</p>
      <p class="eyebrow">Your Complete Ring</p>
      <h2 class="display-md mt-3">${s.setting.name} + ${s.diamond.carat}ct ${s.diamond.shape}</h2>
      <div class="pdp-divider"></div>
      <div class="row-summary">
        <div>
          <p class="eyebrow">Setting</p>
          <p class="col-title">${s.setting.name} · ${s.metal || '14K Yellow Gold'}</p>
          <a href="javascript:galloCustomizer.goToStep(1)" class="col-edit">Change setting</a>
        </div>
        <p class="price-tk color-noir">${fmtMoney(s.setting.price)}</p>
      </div>
      <div class="pdp-divider"></div>
      <div class="row-summary">
        <div>
          <p class="eyebrow">Diamond</p>
          <p class="col-title">${s.diamond.carat} ct ${s.diamond.shape} · ${s.diamond.color} / ${s.diamond.clarity} / ${s.diamond.cut}</p>
          <p class="col-sub">${s.diamond.cert} ${s.diamond.sku}</p>
          <a href="javascript:galloCustomizer.goToStep(2)" class="col-edit">Change diamond</a>
        </div>
        <p class="price-tk color-noir">${fmtMoney(s.diamond.price)}</p>
      </div>
      <div class="pdp-divider"></div>
      <div class="flex" style="justify-content:space-between;align-items:center">
        <div>
          <p class="eyebrow">Ring Size</p>
          <select id="size-select" style="margin-top:8px;height:40px;width:120px">
            <option value="">Select</option>
            ${['4','4.5','5','5.5','6','6.5','7','7.5','8','8.5','9'].map(sz => `<option ${s.ringSize === sz ? 'selected' : ''}>${sz}</option>`).join('')}
            <option value="Not sure" ${s.ringSize === 'Not sure' ? 'selected' : ''}>Not sure — free resize</option>
          </select>
        </div>
        <a href="journal/ring-sizing-guide.html" class="btn-tertiary button-text" target="_blank">Size Guide</a>
      </div>
      <div class="pdp-divider"></div>
      <div class="review-total">
        <p class="label">Total</p>
        <p class="amount">${fmtMoney(total)}</p>
      </div>
      <p class="body-sm color-shadow mt-1">From <strong>${'$' + Math.ceil(total / 12).toLocaleString()}/mo</strong> with Shop Pay Installments · <a href="policies.html#financing">Learn more</a></p>
      <p class="body-sm color-shadow mt-1">Don't know the size? Choose "Not sure" — resizing is free in the first year.</p>
      <div class="cta-stack">
        <button class="btn btn-primary btn-lg btn-full button-text" id="add-bundle-btn" ${!s.ringSize ? 'disabled' : ''}>Add to Cart — ${fmtMoney(total)}</button>
        <a href="visit.html" class="btn-tertiary button-text" style="text-align:center;display:block">Book a consultation →</a>
      </div>
      <div class="trust-strip">
        <span>✓ GIA Certified</span>
        <span>✓ Lifetime Warranty</span>
        <span>✓ Ships in 3 weeks</span>
      </div>
    `;
    document.getElementById('size-select')?.addEventListener('change', (e) => {
      galloCustomizer.setRingSize(e.target.value);
      document.getElementById('add-bundle-btn').disabled = !e.target.value;
    });
    document.getElementById('add-bundle-btn')?.addEventListener('click', () => galloCustomizer.addToCart());
  }

  if (document.querySelector('[data-customizer-stepper]')) {
    // URL param: support deep-link to a specific step
    // ?start=diamond  → jump to Diamond search (step 2), bypassing setting requirement
    // ?step=2         → same effect; ?step=3 jumps to review (if both selected)
    try {
      const params = new URLSearchParams(window.location.search);
      const start = (params.get('start') || '').toLowerCase();
      const stepParam = parseInt(params.get('step'), 10);
      const s = loadCustomizer();
      if (start === 'diamond' || stepParam === 2) {
        s.step = 2;
        saveCustomizer(s);
      } else if (start === 'review' || stepParam === 3) {
        if (s.setting && s.diamond) { s.step = 3; saveCustomizer(s); }
      } else if (start === 'setting' || stepParam === 1) {
        s.step = 1;
        saveCustomizer(s);
      }
    } catch (e) {}

    // Populate the Step-1 settings grid from the catalog. (Kept in gallo.js — which
    // loads fresh from the worker — rather than a page inline script, so it isn't
    // affected by theme-section fetch caching.)
    (function populateSettingGrid() {
      var grid = document.getElementById('setting-grid');
      if (!grid || !window.GALLO_SETTINGS || grid.children.length) return;
      var CDN = window.GALLO_CDN || '';
      grid.innerHTML = window.GALLO_SETTINGS.map(function (s) {
        return '<article class="pcard" style="cursor:pointer" data-setting-sku="' + s.sku + '">'
          + '<div class="pcard-img"><img class="primary" src="' + CDN + s.img + '&width=600" alt="' + s.name + '" loading="lazy"><img class="alt" src="' + CDN + s.alt + '&width=600" alt="' + s.name + ' alternate" loading="lazy"></div>'
          + '<div class="pcard-info"><h3>' + s.name + '</h3><p class="price-tk color-noir">From $' + s.price.toLocaleString() + '</p><p class="body-sm">' + s.sub + '</p>'
          + '<div class="card-metals" role="group" aria-label="Metal options">' + s.metals.map(function (m) { return '<button type="button" class="card-metal-dot' + (m === 'white' ? ' active' : '') + '" data-metal="' + m + '" aria-label="' + m + '"></button>'; }).join('') + '</div>'
          + '<button class="btn btn-secondary btn-full button-text" style="margin-top:16px">Select This Setting →</button></div></article>';
      }).join('');
      grid.addEventListener('metal-change', function (e) {
        var dot = e.target.closest('.card-metal-dot'), card = e.target.closest('[data-setting-sku]');
        if (!dot || !card) return;
        var st = window.GALLO_SETTINGS.find(function (x) { return x.sku === card.dataset.settingSku; });
        var path = st && st.metalImgs && st.metalImgs[dot.dataset.metal];
        if (!path) return;
        var img = card.querySelector('img.primary');
        if (img) img.src = CDN + path + (path.indexOf('?') > -1 ? '&' : '?') + 'width=600';
      });
      grid.querySelectorAll('[data-setting-sku]').forEach(function (el) {
        el.addEventListener('click', function () {
          var st = window.GALLO_SETTINGS.find(function (x) { return x.sku === el.dataset.settingSku; });
          var dot = el.querySelector('.card-metal-dot.active');
          if (st && window.galloCustomizer) window.galloCustomizer.selectSetting(st, dot ? dot.dataset.metal : 'white', st.shape);
        });
      });
    })();

    renderCustomizer();
  }

  // ---------- INIT ----------
  // Render cart drawer on page load (in case it's open via deep link or hash)
  renderCartDrawer();

  // Newsletter form fake-submit
  document.querySelectorAll('.newsletter-form').forEach(form => {
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      showToast('Thank you. Welcome to Gallo.');
      form.reset();
    });
  });

  // Filter dropdown toggle (PLP)
  document.addEventListener('click', (e) => {
    const trig = e.target.closest('.filter-trigger');
    if (trig) {
      e.preventDefault();
      showToast('Filter panel — demo: full implementation in React components');
    }
  });

})();

// ---------- FILTER DRAWER ----------
(function() {
  const drawer = document.getElementById('filter-drawer');
  if (!drawer) return;
  const backdrop = document.querySelector('.filter-backdrop');
  const openers = document.querySelectorAll('[data-filter-open]');
  const closers = document.querySelectorAll('[data-filter-close]');
  const resets = document.querySelectorAll('[data-filter-reset]');
  const applys = document.querySelectorAll('[data-filter-apply]');

  function openDrawer() {
    drawer.classList.add('open');
    backdrop?.classList.add('open');
    drawer.setAttribute('aria-hidden', 'false');
    openers.forEach(b => b.setAttribute('aria-expanded', 'true'));
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer() {
    drawer.classList.remove('open');
    backdrop?.classList.remove('open');
    drawer.setAttribute('aria-hidden', 'true');
    openers.forEach(b => b.setAttribute('aria-expanded', 'false'));
    document.body.style.overflow = '';
  }
  openers.forEach(b => b.addEventListener('click', openDrawer));
  closers.forEach(b => b.addEventListener('click', closeDrawer));
  resets.forEach(b => b.addEventListener('click', () => {
    drawer.querySelectorAll('input[type="checkbox"]').forEach(cb => cb.checked = false);
    drawer.querySelectorAll('input[type="number"]').forEach(n => n.value = '');
  }));
  applys.forEach(b => b.addEventListener('click', closeDrawer));
  document.addEventListener('keydown', e => { if (e.key === 'Escape' && drawer.classList.contains('open')) closeDrawer(); });
})();

// ---------- DIAMOND FILTER — live VDB API ----------
(function() {
  const section = document.querySelector('[data-step="2"]');
  if (!section) return;

  // Update this URL after deploying the Cloudflare Worker (worker/diamonds-proxy.js)
  const PROXY_URL = 'https://gallo-diamonds.gallojewelry.workers.dev';

  const COLOR_ORDER    = ['D','E','F','G','H','I','J','K','L','M','N'];
  const CLARITY_ORDER  = ['FL','IF','VVS1','VVS2','VS1','VS2','SI1','SI2','I1','I2','I3'];
  const GRADE_ORDER    = ['Ideal','Excellent','Very Good','Good','Fair','Poor'];

  const PAGE_SIZE = 24;
  let currentPage = 1;
  let totalFound  = 0;
  let fetchTimer  = null;
  let viewMode    = 'grid';   // 'grid' | 'list'
  let loaded      = [];        // accumulated diamonds across Load More
  // Simple 60-second in-memory cache
  const cache = new Map();

  // --- Helpers ---

  function selectedVals(group) {
    return Array.from(section.querySelectorAll(`[data-filter-group="${group}"] .dpill.selected`))
      .map(p => p.dataset.val);
  }

  function gradeRange(order, vals) {
    if (!vals.length) return null;
    const idxs = vals.map(v => order.indexOf(v)).filter(i => i >= 0);
    if (!idxs.length) return null;
    return { from: order[Math.min(...idxs)], to: order[Math.max(...idxs)] };
  }

  function buildParams(page) {
    const p = new URLSearchParams();

    // Type: lab-grown vs natural
    const dtype = section.querySelector('.diamond-type-pill.active')?.dataset.dtype || 'lab';
    p.set('type', dtype === 'natural' ? 'Diamond' : 'Lab_grown_Diamond');

    // Shape (single-select tile)
    const shape = section.querySelector('.dshape-tile.selected')?.dataset.shape;
    if (shape) p.append('shapes[]', shape);

    // Price
    const priceMin = parseFloat(document.getElementById('price-min')?.value || 500);
    const priceMax = parseFloat(document.getElementById('price-max')?.value || 50000);
    p.set('price_total_from', Math.round(priceMin));
    if (priceMax < 50000) p.set('price_total_to', Math.round(priceMax));

    // Carat
    const caratMin = parseFloat(document.getElementById('carat-min')?.value || 0.30);
    const caratMax = parseFloat(document.getElementById('carat-max')?.value || 10);
    p.set('size_from', caratMin.toFixed(2));
    if (caratMax < 10) p.set('size_to', caratMax.toFixed(2));

    // Cut / Color / Clarity — convert pill selection to grade range
    const cutR = gradeRange(GRADE_ORDER, selectedVals('cut'));
    if (cutR) { p.set('cut_from', cutR.from); p.set('cut_to', cutR.to); }

    const colR = gradeRange(COLOR_ORDER, selectedVals('color'));
    if (colR) { p.set('color_from', colR.from); p.set('color_to', colR.to); }

    const clrR = gradeRange(CLARITY_ORDER, selectedVals('clarity'));
    if (clrR) { p.set('clarity_from', clrR.from); p.set('clarity_to', clrR.to); }

    // Polish & Symmetry
    const polR = gradeRange(GRADE_ORDER, selectedVals('polish'));
    if (polR) { p.set('polish_from', polR.from); p.set('polish_to', polR.to); }

    const symR = gradeRange(GRADE_ORDER, selectedVals('symmetry'));
    if (symR) { p.set('symmetry_from', symR.from); p.set('symmetry_to', symR.to); }

    // Certifications (labs[])
    selectedVals('cert').forEach(v => p.append('labs[]', v));

    // Fluorescence
    selectedVals('fluor').forEach(v => p.append('fluorescence_intensities[]', v));

    // Note: preference[] param omitted — VDB uses default sort order

    // Pagination
    p.set('page_number', page);
    p.set('page_size', PAGE_SIZE);
    p.set('with_images', 'true');
    p.set('show_unavailable', 'false');

    return p;
  }

  // --- Render ---

  function fmtMoney(v) {
    return v ? '$' + Math.round(v).toLocaleString() : '—';
  }

  // Sort the accumulated set client-side per the sort dropdown
  function sortDiamonds(arr) {
    const v = document.getElementById('diamond-sort')?.value || 'best';
    const CUT = { 'Ideal':0, 'Excellent':1, 'Very Good':2, 'Good':3, 'Fair':4, 'Poor':5 };
    const out = arr.slice();
    const price = d => parseFloat(d.total_sales_price || d.price_total || d.price || 0);
    if (v === 'price-asc')  out.sort((a,b) => price(a) - price(b));
    else if (v === 'price-desc') out.sort((a,b) => price(b) - price(a));
    else if (v === 'carat-desc') out.sort((a,b) => parseFloat(b.size||0) - parseFloat(a.size||0));
    else if (v === 'cut')   out.sort((a,b) => (CUT[a.cut] ?? 9) - (CUT[b.cut] ?? 9));
    // 'best' keeps VDB's native order
    return out;
  }

  // Render whichever view is active from the accumulated `loaded` set
  function renderResults() {
    const grid  = document.getElementById('diamond-grid');
    const table = document.getElementById('diamond-table');
    const tbody = table?.querySelector('tbody');
    const list  = sortDiamonds(loaded);

    if (grid)  grid.hidden  = viewMode !== 'grid';
    if (table) table.hidden = viewMode !== 'list';

    if (viewMode === 'grid') renderGrid(list, grid);
    else renderRows(list, tbody);
  }

  function rowActions(d) {
    return {
      open: () => openDetail(d),
      select: (e) => { e.stopPropagation(); selectStone(d); },
    };
  }

  function renderGrid(diamonds, grid) {
    if (!grid) return;
    grid.innerHTML = '';
    if (!diamonds.length) {
      grid.innerHTML = '<p class="dgrid-empty">No diamonds match your filters — try widening the search.</p>';
      return;
    }
    const frag = document.createDocumentFragment();
    diamonds.forEach(d => {
      const price = d.total_sales_price || d.price_total || d.price;
      const carat = d.size ? parseFloat(d.size).toFixed(2) : '';
      const card = document.createElement('div');
      card.className = 'dcard';
      card.innerHTML = `
        <div class="dcard-media"${d.video_url ? ` data-video="${d.video_url}" data-id="${d.id}"` : ''}>
          ${d.image_url
            ? `<img src="${PROXY_URL}/img?u=${encodeURIComponent(d.image_url)}" alt="${d.shape || 'Diamond'} diamond" loading="lazy" draggable="false" onerror="this.style.display='none';this.parentNode.insertAdjacentHTML('afterbegin','<div class=\\'dcard-noimg\\'>${(d.shape || 'Diamond').replace(/'/g,'')}</div>')">`
            : `<div class="dcard-noimg">${d.shape || 'Diamond'}</div>`}
          ${d.video_url ? '<span class="dcard-360">360°</span>' : ''}
        </div>
        <div class="dcard-body">
          <p class="dcard-title">${carat} ct ${d.shape || ''} Lab Diamond</p>
          <p class="dcard-specs">${[d.cut, d.color, d.clarity, d.lab].filter(Boolean).join(' · ')}</p>
          <p class="dcard-price">${fmtMoney(price)}</p>
          <div class="dcard-actions">
            <button type="button" class="btn btn-primary btn-sm button-text dcard-select">Select</button>
            <button type="button" class="dcard-view button-text">View Details</button>
          </div>
        </div>
      `;
      const a = rowActions(d);
      card.addEventListener('click', (e) => {
        if (e.target.closest('.dcard-select')) return;
        if (card._dragMoved) { card._dragMoved = false; return; }  // was a rotate-drag, not a click
        a.open();
      });
      card.querySelector('.dcard-select').addEventListener('click', a.select);
      // side-by-side comparison (max 3 stones)
      const cmp = document.createElement('button');
      cmp.type = 'button'; cmp.className = 'dcard-compare'; cmp.textContent = 'Compare';
      cmp.addEventListener('click', (e) => { e.stopPropagation(); toggleCompare(d, cmp); });
      cmp.classList.toggle('on', compareList.some(x => x.id === d.id));
      card.querySelector('.dcard-media')?.appendChild(cmp);
      // Hover reveals the stone and it AUTO-rotates at a steady, time-based pace.
      // Click-and-drag on the picture rotates it by hand and stops the auto-spin.
      const media = card.querySelector('.dcard-media[data-video]');
      if (media) {
        media._open = a.open;   // the embedded viewer reports clean clicks → open the popup
        if (HOVER_OK) {         // touch devices skip the hover viewers (data + main-thread cost)
          card.addEventListener('mouseenter', () => spinOnly(media));
          card.addEventListener('mouseleave', () => deactivateSpin(media));
          wireDrag(card, media);
        }
      }
      frag.appendChild(card);
    });
    grid.appendChild(frag);
    preloadInView(grid);   // build spinners for visible cards in the background
  }

  const spinUrl = (video) => `${PROXY_URL}/spin?v=27&u=${encodeURIComponent(video)}`;
  // The vendor's viewer with its buttons/logos hidden by the worker (/spin-view).
  const spinViewUrl = (video) => `${PROXY_URL}/spin-view?v=7&u=${encodeURIComponent(video)}`;

  // The embedded viewer posts {gallo360:'click'} for a clean click (press+release,
  // no movement) — open that stone's detail popup. Drags never send this, so
  // hold-and-rotate keeps working untouched.
  window.addEventListener('message', (e) => {
    if (!e.data || e.data.gallo360 !== 'click') return;
    document.querySelectorAll('.dcard-media iframe').forEach((f) => {
      if (f.contentWindow === e.source) {
        const media = f.closest('.dcard-media');
        if (media && media._open) media._open();
      }
    });
  });
  const spinSpriteUrl = (id) => `${PROXY_URL}/spin-sprite?id=${encodeURIComponent(id)}&v=6`;
  // Only preload on devices that can actually hover (desktop) — never on touch.
  const HOVER_OK = !window.matchMedia || window.matchMedia('(hover:hover) and (pointer:fine)').matches;

  // ---------- COMPARE STONES (side-by-side confidence builder) ----------
  const compareList = [];
  function toggleCompare(d, btn) {
    const i = compareList.findIndex(x => x.id === d.id);
    if (i >= 0) compareList.splice(i, 1);
    else if (compareList.length >= 3) { window.showToast?.('Compare up to 3 stones'); return; }
    else compareList.push(d);
    btn?.classList.toggle('on', i < 0);
    renderCompareBar();
  }
  function renderCompareBar() {
    let bar = document.getElementById('compare-bar');
    if (!compareList.length) { bar?.remove(); return; }
    if (!bar) {
      bar = document.createElement('button');
      bar.id = 'compare-bar'; bar.type = 'button';
      bar.addEventListener('click', openCompare);
      document.body.appendChild(bar);
    }
    bar.textContent = 'Compare ' + compareList.length + (compareList.length > 1 ? ' stones →' : ' stone (pick another)');
  }
  function openCompare() {
    if (compareList.length < 2) return;
    let m = document.getElementById('compare-modal');
    m?.remove();
    m = document.createElement('div');
    m.id = 'compare-modal'; m.className = 'ddetail-backdrop';
    const rows = [['Carat', d => d.size ? parseFloat(d.size).toFixed(2) : '—'], ['Shape', d => d.shape || '—'],
      ['Color', d => d.color || '—'], ['Clarity', d => d.clarity || '—'], ['Cut', d => d.cut || '—'],
      ['Polish', d => d.polish || '—'], ['Symmetry', d => d.symmetry || '—'], ['Lab', d => d.lab || '—'],
      ['Price', d => fmtMoney(d.total_sales_price || d.price)],
      ['$ / carat', d => fmtMoney((d.total_sales_price || d.price) / parseFloat(d.size || 1))]];
    m.innerHTML = '<div class="ddetail-panel" role="dialog" aria-modal="true" style="max-width:760px">' +
      '<button type="button" class="ddetail-close" aria-label="Close">&times;</button>' +
      '<div style="padding:28px;overflow:auto"><p class="eyebrow" style="margin-bottom:14px">Side by Side</p>' +
      '<table class="dt" style="width:100%"><thead><tr><th></th>' +
      compareList.map(d => '<th style="text-align:center"><img src="' + (d.image_url || '') + '" alt="" style="width:84px;height:84px;object-fit:cover;border-radius:4px"></th>').join('') +
      '</tr></thead><tbody>' +
      rows.map(([label, fn]) => '<tr><td style="color:var(--ink-shadow)">' + label + '</td>' +
        compareList.map(d => '<td style="text-align:center">' + fn(d) + '</td>').join('') + '</tr>').join('') +
      '<tr><td></td>' + compareList.map((d, i) =>
        '<td style="text-align:center"><button type="button" class="btn btn-primary button-text" data-csel="' + i + '" style="padding:8px 14px">Select</button></td>').join('') +
      '</tr></tbody></table></div></div>';
    document.body.appendChild(m);
    m.addEventListener('click', (e) => {
      if (e.target === m || e.target.closest('.ddetail-close')) m.remove();
      const b = e.target.closest('[data-csel]');
      if (b) { m.remove(); selectStone(compareList[+b.dataset.csel]); }
    });
  }

  // ---------- RECENTLY VIEWED STONES (diamond shopping is multi-session) ----------
  const RECENT_KEY = 'galloRecentStones';
  function recentStones() { try { return JSON.parse(localStorage.getItem(RECENT_KEY)) || []; } catch (e) { return []; } }
  function trackRecentStone(d) {
    try {
      const l = recentStones().filter(x => x.id !== d.id);
      l.unshift(d);
      localStorage.setItem(RECENT_KEY, JSON.stringify(l.slice(0, 8)));
    } catch (e) {}
    renderRecentStrip();
  }
  function renderRecentStrip() {
    const host = document.querySelector('.diamond-shape-rail .container');
    const list = recentStones();
    if (!host || !list.length) return;
    let strip = document.getElementById('recent-stones');
    if (!strip) { strip = document.createElement('div'); strip.id = 'recent-stones'; host.appendChild(strip); }
    strip.innerHTML = '<p class="eyebrow" style="margin:18px 0 8px">Recently viewed stones</p><div class="recent-row">' +
      list.map((d, i) => `<button type="button" class="recent-stone" data-ri="${i}">
        <img src="${d.image_url || ''}" alt="${d.shape || 'Diamond'}" loading="lazy">
        <span>${d.size ? parseFloat(d.size).toFixed(2) : '—'}ct ${d.shape || ''}</span>
        <span class="price-tk">${fmtMoney(d.total_sales_price || d.price)}</span></button>`).join('') + '</div>';
    strip.querySelectorAll('.recent-stone').forEach(b =>
      b.addEventListener('click', () => openDetail(list[+b.dataset.ri])));
  }
  function wireDetailWish(m, d, carat, price) {
    let w = m.querySelector('.ddetail-wish');
    if (!w) {
      w = document.createElement('button');
      w.type = 'button'; w.className = 'ddetail-wish';
      m.querySelector('.ddetail-title')?.insertAdjacentElement('afterend', w);
    }
    const id = 'stone-' + d.id;
    const sync = () => { w.innerHTML = (window.galloWish?.has(id) ? '♥ Saved' : '♡ Save this stone'); };
    w.onclick = () => {
      window.galloWish?.toggle({ id, title: `${d.size ? parseFloat(d.size).toFixed(2) : ''}ct ${d.shape || ''} Lab Diamond`,
        price: Math.round(price || 0), img: d.image_url || '', href: 'diamonds.html', stone: d });
      sync();
      window.showToast?.(window.galloWish?.has(id) ? 'Stone saved to your wishlist' : 'Removed from wishlist');
    };
    sync();
  }


  // Exactly like Brilliant Earth's V360 spin module: a SPRITE SHEET of frames, and
  // the mouse position maps DIRECTLY to the frame (no easing/lag) — that direct swap
  // is what makes it feel smooth and responsive. Layout MUST match the encoder.
  const SPRITE_COLS = 16, SPRITE_ROWS = 8, SPRITE_N = 128;
  const PRELOAD_CAP = 12;      // viewers kept mounted at once — more = more instant hovers
  const MAX_CONCURRENT = 4;    // max simultaneous loads
  const loadedMedia = [];      // media elements with a live spinner (sprite or iframe)
  const wanted = new Set();    // media that should be loaded (in view or hovered)
  let activeLoads = 0;

  // Draw the real frame for `index` from the loaded sprite "film strip" onto the
  // card's <canvas>. This is genuine image-sequence frame-swapping — each draw is a
  // different captured photo, so the facets actually move. The sprite is one decoded
  // image = every frame preloaded, so swaps are instant with zero flicker.
  function drawFrame(media, index) {
    const sprite = media._sprite, cv = media._canvas;
    if (!sprite || !cv) return;
    const fw = media._fw, fh = media._fh;
    const col = index % SPRITE_COLS, row = Math.floor(index / SPRITE_COLS);
    cv.getContext('2d').drawImage(sprite, col * fw, row * fh, fw, fh, 0, 0, cv.width, cv.height);
  }

  const hasSpinner = (media) => !!media.querySelector('.dcard-canvas, iframe');

  function mountIframe(media, done) {
    // THE SAME 360° viewer the detail popup shows (the vendor's own player, with
    // its native pace, clarity and drag behavior) — embedded directly, untouched.
    // The owner judged the popup viewer perfect; the card simply shows that.
    const ifr = document.createElement('iframe');
    ifr.src = spinViewUrl(media.dataset.video);
    ifr.title = '360° diamond view';
    ifr.setAttribute('allow', 'autoplay; fullscreen');
    ifr.setAttribute('scrolling', 'no');
    // no loading="lazy": we mount on purpose (preload queue), so load immediately
    let settled = false;
    const fin = () => { if (settled) return; settled = true; done(); };
    ifr.addEventListener('load', fin);
    setTimeout(fin, 8000);   // don't let a stuck load block the queue forever
    media.appendChild(ifr);
  }

  function createSpinnerNow(media) {
    if (!media || hasSpinner(media) || !media.dataset.video) return;
    // evict an old preloaded spinner (not hovered, not currently wanted) if full
    while (loadedMedia.length >= PRELOAD_CAP) {
      const old = loadedMedia.find(m => m !== media && !m.classList.contains('is-spinning') && !wanted.has(m));
      if (!old) break;
      removeSpinner(old);
    }
    activeLoads++;
    let settled = false;
    const done = () => { if (settled) return; settled = true; activeLoads--; pump(); };
    mountIframe(media, done);
    loadedMedia.push(media);
  }

  // Process the queue: load the highest-priority wanted cards (nearest the top
  // of the viewport) up to the concurrency limit.
  function pump() {
    if (activeLoads >= MAX_CONCURRENT) return;
    const candidates = [...wanted].filter(m => m.isConnected && !hasSpinner(m));
    candidates.sort((a, b) => Math.abs(a.getBoundingClientRect().top) - Math.abs(b.getBoundingClientRect().top));
    for (const m of candidates) {
      if (activeLoads >= MAX_CONCURRENT) break;
      createSpinnerNow(m);
    }
  }

  function removeSpinner(media) {
    const el = media.querySelector('.dcard-canvas, iframe');
    if (el) el.remove();
    media._canvas = null; media._sprite = null;
    if (media._raf) { cancelAnimationFrame(media._raf); media._raf = 0; }
    media.classList.remove('is-spinning');
    const i = loadedMedia.indexOf(media);
    if (i >= 0) loadedMedia.splice(i, 1);
  }

  // Reveal the stone on hover and AUTO-rotate it (no mouse-scrubbing).
  function spinOnly(media) {
    document.querySelectorAll('.dcard-media.is-spinning').forEach(m => {
      if (m !== media) { m.classList.remove('is-spinning'); if (m._raf) { cancelAnimationFrame(m._raf); m._raf = 0; } }
    });
    wanted.add(media);
    if (!hasSpinner(media)) createSpinnerNow(media);  // hover = top priority, load now
    media.classList.add('is-spinning');
    startSpin(media);   // starts now, or the moment the sprite finishes loading
  }

  // Time-based auto-rotation: a steady requestAnimationFrame loop advances through
  // the frames at a constant rate (frames-per-second = TOTAL_FRAMES / SECONDS_PER_REV).
  // dt is clamped so a backgrounded tab can't make it jump. TWO KNOBS, tunable here:
  const TOTAL_FRAMES = SPRITE_N;   // use all captured frames — more frames = smoother
  const SECONDS_PER_REV = 16;      // higher = slower (one calm turn every 16s)
  function startSpin(media) {
    if (media._raf) return;
    if (!media._sprite || !media._canvas) return;   // not loaded yet → started later by onload
    if (media._pos === undefined) { media._pos = 0; media._frame = -1; }
    let last = 0;
    const loop = (t) => {
      if (!media.classList.contains('is-spinning') || !media._canvas) { media._raf = 0; return; }
      if (!last) last = t;
      const dt = Math.min(t - last, 100); last = t;   // clamp so tab-switch can't jump
      if (!media._hold) {                             // grabbed/stopped → hold the frame
        media._pos = (media._pos + (dt / 1000) * (TOTAL_FRAMES / SECONDS_PER_REV)) % TOTAL_FRAMES;
        const next = Math.floor(media._pos);
        if (next !== media._frame) { media._frame = next; drawFrame(media, next); }  // swap the real frame
      }
      media._raf = requestAnimationFrame(loop);
    };
    media._raf = requestAnimationFrame(loop);
  }
  function deactivateSpin(media) {
    media.classList.remove('is-spinning');  // hide, but keep the sprite loaded
    media._hold = false;                    // a fresh hover always spins again
    media.classList.remove('dragging');
    if (media._raf) { cancelAnimationFrame(media._raf); media._raf = 0; }
  }

  // Click-and-drag rotates the stone by hand: direct mapping, one full turn per
  // card width, no easing (Brilliant-Earth feel). Grabbing pauses the auto-spin;
  // releasing leaves the stone where you put it until you hover away and back.
  function wireDrag(card, media) {
    let downX = 0, startPos = 0;
    media.style.touchAction = 'pan-y';   // horizontal drag rotates, vertical still scrolls
    card.addEventListener('pointerdown', (e) => {
      if (!media._sprite || !media._canvas) return;
      if (e.target.closest('.dcard-body')) return;   // only grab on the picture itself
      media._hold = true;
      media.classList.add('dragging');
      downX = e.clientX; startPos = media._pos || 0;
      try { card.setPointerCapture(e.pointerId); } catch (_) {}
      e.preventDefault();
    });
    card.addEventListener('pointermove', (e) => {
      if (!media._hold || !media.classList.contains('dragging')) return;
      const dx = e.clientX - downX;
      if (Math.abs(dx) > 5) card._dragMoved = true;   // real drag → swallow the click
      const w = media.clientWidth || 1;
      let p = (startPos + (dx / w) * TOTAL_FRAMES) % TOTAL_FRAMES;
      if (p < 0) p += TOTAL_FRAMES;
      media._pos = p;
      const next = Math.floor(p);
      if (next !== media._frame) { media._frame = next; drawFrame(media, next); }
    });
    const release = () => { media.classList.remove('dragging'); };  // stays stopped (_hold keeps it)
    card.addEventListener('pointerup', release);
    card.addEventListener('pointercancel', release);
  }

  // Watch which cards are on screen; queue them for preload, drop them when gone.
  let viewObs = null;
  function preloadInView(grid) {
    if (viewObs) viewObs.disconnect();
    if (!HOVER_OK || !('IntersectionObserver' in window)) return;
    viewObs = new IntersectionObserver((entries) => {
      entries.forEach(e => {
        if (e.isIntersecting) { wanted.add(e.target); }
        else {
          wanted.delete(e.target);
          if (!e.target.classList.contains('is-spinning')) removeSpinner(e.target);
        }
      });
      pump();
    }, { rootMargin: '200px 0px' });
    grid.querySelectorAll('.dcard-media[data-video]').forEach(m => viewObs.observe(m));
  }

  function renderRows(diamonds, tbody) {
    if (!tbody) return;
    tbody.innerHTML = '';
    if (!diamonds.length) {
      tbody.innerHTML = '<tr><td colspan="8" class="dt-empty">No diamonds match your filters — try widening the search.</td></tr>';
      return;
    }
    const frag = document.createDocumentFragment();
    diamonds.forEach(d => {
      const tr = document.createElement('tr');
      tr.className = 'dt-row';
      const price = d.total_sales_price || d.price_total || d.price;
      tr.innerHTML = `
        <td>${d.shape || '—'}</td>
        <td class="num">${d.size ? parseFloat(d.size).toFixed(2) : '—'}</td>
        <td>${d.cut || '—'}</td>
        <td class="cent">${d.color || '—'}</td>
        <td class="cent">${d.clarity || '—'}</td>
        <td>${d.lab || '—'}</td>
        <td class="num">${fmtMoney(price)}</td>
        <td>
          <button type="button" class="dt-view-btn button-text">View</button>
          <button type="button" class="btn btn-primary btn-sm button-text dt-select-btn">Select</button>
        </td>
      `;
      const a = rowActions(d);
      tr.addEventListener('click', (e) => { if (e.target.closest('.dt-select-btn')) return; a.open(); });
      tr.querySelector('.dt-select-btn').addEventListener('click', a.select);
      frag.appendChild(tr);
    });
    tbody.appendChild(frag);
  }

  function selectStone(d) {
    const price = d.total_sales_price || d.price_total || d.price;
    if (window.galloCustomizer?.selectDiamond) {
      galloCustomizer.selectDiamond({
        sku: d.id,
        shape: d.shape,
        carat: parseFloat(d.size),
        cut: d.cut,
        color: d.color,
        clarity: d.clarity,
        cert: d.lab,
        certNum: d.cert_num,
        price: Math.round(price || 0),
        image: d.image_url,
      });
    }
    closeDetail();
  }

  // --- Diamond detail modal ---

  let detailEl = null;

  function ensureDetailModal() {
    if (detailEl) return detailEl;
    detailEl = document.createElement('div');
    detailEl.className = 'ddetail-backdrop';
    detailEl.hidden = true;
    detailEl.innerHTML = `
      <div class="ddetail-panel" role="dialog" aria-modal="true" aria-label="Diamond details">
        <button type="button" class="ddetail-close" aria-label="Close">&times;</button>
        <div class="ddetail-body">
          <div class="ddetail-media">
            <div class="ddetail-media-stage"></div>
            <div class="ddetail-media-tabs"></div>
          </div>
          <div class="ddetail-info">
            <p class="ddetail-eyebrow">Lab-Grown Diamond</p>
            <h3 class="ddetail-title"></h3>
            <p class="ddetail-price"></p>
            <div class="ddetail-specs"></div>
            <div class="ddetail-actions"></div>
            <p class="ddetail-note"></p>
          </div>
        </div>
      </div>
    `;
    document.body.appendChild(detailEl);
    detailEl.addEventListener('click', (e) => {
      if (e.target === detailEl || e.target.closest('.ddetail-close')) closeDetail();
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && !detailEl.hidden) closeDetail();
    });
    return detailEl;
  }

  function spec(label, val) {
    if (val == null || val === '' ) return '';
    return `<div class="ddetail-spec"><span class="ddetail-spec-l">${label}</span><span class="ddetail-spec-v">${val}</span></div>`;
  }

  function openDetail(d) {
    const m = ensureDetailModal();
    const price = d.total_sales_price || d.price_total || d.price;
    const carat = d.size ? parseFloat(d.size).toFixed(2) : '—';

    m.querySelector('.ddetail-title').textContent = d.title || `${d.shape || ''} ${carat}ct ${d.color || ''} ${d.clarity || ''}`.trim();
    m.querySelector('.ddetail-price').textContent = fmtMoney(price);
    trackRecentStone(d);
    wireDetailWish(m, d, carat, price);

    m.querySelector('.ddetail-specs').innerHTML =
      spec('Shape', d.shape) +
      spec('Carat', carat) +
      spec('Color', d.color) +
      spec('Clarity', d.clarity) +
      spec('Cut', d.cut) +
      spec('Polish', d.polish) +
      spec('Symmetry', d.symmetry) +
      spec('Fluorescence', d.fluorescence) +
      spec('Measurements', d.measurement) +
      spec('L/W Ratio', d.meas_ratio) +
      spec('Depth', d.depth_percent ? d.depth_percent + '%' : null) +
      spec('Table', d.table_percent ? d.table_percent + '%' : null) +
      spec('Lab', d.lab) +
      spec('Report #', d.cert_num) +
      spec('Location', d.location);

    // Media: 360° video (default) + photo tabs
    const stage = m.querySelector('.ddetail-media-stage');
    const tabs = m.querySelector('.ddetail-media-tabs');
    const setActive = (btn) => {
      tabs.querySelectorAll('.ddetail-tab').forEach(t => t.classList.remove('active'));
      if (btn) btn.classList.add('active');
    };
    const showPhoto = () => {
      stage.innerHTML = d.image_url
        ? `<img src="${d.image_url}" alt="${d.shape || 'Diamond'}" loading="lazy">`
        : `<div class="ddetail-noimg">No image available</div>`;
    };
    const showVideo = () => {
      stage.innerHTML = `<iframe src="${d.video_url}" title="360° diamond video" allow="fullscreen" loading="lazy"></iframe>`;
    };

    tabs.innerHTML = '';
    let videoBtn = null, photoBtn = null;
    // 360° Video tab first so it leads the experience
    if (d.video_url) {
      videoBtn = document.createElement('button');
      videoBtn.className = 'ddetail-tab'; videoBtn.textContent = '360° Video';
      videoBtn.onclick = () => { showVideo(); setActive(videoBtn); };
      tabs.appendChild(videoBtn);
    }
    if (d.image_url) {
      photoBtn = document.createElement('button');
      photoBtn.className = 'ddetail-tab'; photoBtn.textContent = 'Photo';
      photoBtn.onclick = () => { showPhoto(); setActive(photoBtn); };
      tabs.appendChild(photoBtn);
    }

    // Default to the 360° video; fall back to photo if no video is available
    if (d.video_url) { showVideo(); setActive(videoBtn); }
    else { showPhoto(); setActive(photoBtn); }

    // Actions
    const actions = m.querySelector('.ddetail-actions');
    actions.innerHTML = '';
    const selectBtn = document.createElement('button');
    selectBtn.className = 'btn btn-primary button-text';
    selectBtn.textContent = 'Select This Diamond';
    selectBtn.onclick = () => selectStone(d);
    actions.appendChild(selectBtn);
    if (d.cert_url) {
      const cert = document.createElement('a');
      cert.className = 'btn btn-secondary button-text';
      cert.href = d.cert_url; cert.target = '_blank'; cert.rel = 'noopener';
      cert.textContent = 'View Certificate';
      actions.appendChild(cert);
    }

    m.querySelector('.ddetail-note').textContent = d.available
      ? 'In stock — ready to set in your custom ring.'
      : '';

    m.hidden = false;
    document.body.style.overflow = 'hidden';
  }

  function closeDetail() {
    if (detailEl) { detailEl.hidden = true; document.body.style.overflow = ''; }
  }

  function setLoading(on) {
    document.querySelector('.dt-wrap')?.classList.toggle('dt-loading', on);
  }

  function updateMeta(total, shownCount) {
    document.querySelectorAll('[data-diamond-count]').forEach(el => el.textContent = total.toLocaleString());
    const pText = document.querySelector('.pagination .body-sm');
    if (pText) pText.innerHTML = `Showing ${shownCount.toLocaleString()} of <span data-diamond-count>${total.toLocaleString()}</span>`;
    const loadBtn = document.querySelector('.pagination .btn');
    if (loadBtn) loadBtn.hidden = shownCount >= total;
  }

  function showError() {
    const grid = document.getElementById('diamond-grid');
    const tbody = document.querySelector('#diamond-table tbody');
    if (grid) grid.innerHTML = '<p class="dgrid-empty">Could not load diamonds — please try again.</p>';
    if (tbody) tbody.innerHTML = '<tr><td colspan="8" class="dt-empty">Could not load diamonds — please try again.</td></tr>';
  }

  // --- Fetch ---

  function showSkeletons() {
    const grid = document.getElementById('diamond-grid');
    if (!grid) return;
    grid.innerHTML = Array.from({ length: 8 }, () =>
      '<div class="dcard-skel"><div class="i"></div><div class="l"></div><div class="l s"></div></div>').join('');
  }

  async function fetchDiamonds(page, append) {
    const params = buildParams(page);
    const cacheKey = params.toString();
    const hot = cache.get(cacheKey);
    if (!append && !(hot && Date.now() - hot.ts < 60000)) showSkeletons();

    if (!append) {
      const hit = cache.get(cacheKey);
      if (hit && Date.now() - hit.ts < 60000) {
        loaded = hit.diamonds.slice();
        totalFound = hit.total;
        renderResults();
        updateMeta(totalFound, loaded.length);
        return;
      }
    }

    setLoading(true);
    try {
      const resp = await fetch(`${PROXY_URL}?${params}`);
      if (!resp.ok) throw new Error(`HTTP ${resp.status}`);
      const data = await resp.json();

      const diamonds = data.diamonds || [];
      totalFound = data.total_diamonds_found || diamonds.length;

      if (!append) {
        loaded = diamonds.slice();
        cache.set(cacheKey, { diamonds: loaded.slice(), total: totalFound, ts: Date.now() });
      } else {
        loaded = loaded.concat(diamonds);
      }

      renderResults();
      updateMeta(totalFound, loaded.length);
    } catch (err) {
      console.error('VDB fetch failed:', err);
      if (!append) { loaded = []; showError(); }
    } finally {
      setLoading(false);
    }
  }

  function scheduleRefresh() {
    clearTimeout(fetchTimer);
    fetchTimer = setTimeout(() => { currentPage = 1; fetchDiamonds(1, false); }, 400);
  }

  // --- Wire UI ---

  // Shape tiles
  section.querySelectorAll('.dshape-tile').forEach(tile => {
    tile.addEventListener('click', () => {
      section.querySelectorAll('.dshape-tile').forEach(t => t.classList.remove('selected'));
      tile.classList.add('selected');
      scheduleRefresh();
    });
  });

  // Filter pills
  section.querySelectorAll('.dfilter-pills .dpill').forEach(pill => {
    pill.addEventListener('click', () => { pill.classList.toggle('selected'); scheduleRefresh(); });
  });

  // Lab / Natural toggle
  section.querySelectorAll('.diamond-type-pill').forEach(b => {
    b.addEventListener('click', () => {
      section.querySelectorAll('.diamond-type-pill').forEach(p => p.classList.remove('active'));
      b.classList.add('active');
      scheduleRefresh();
    });
  });

  // Dual range sliders
  function setupRange(minId, maxId, fillId, valId, formatter) {
    const minEl = document.getElementById(minId);
    const maxEl = document.getElementById(maxId);
    const fillEl = document.getElementById(fillId);
    const valEl = document.getElementById(valId);
    if (!minEl || !maxEl) return;
    const update = () => {
      let lo = parseFloat(minEl.value), hi = parseFloat(maxEl.value);
      if (lo > hi - 0.05) {
        if (event?.target === minEl) minEl.value = hi - 0.05;
        else maxEl.value = lo + 0.05;
        lo = parseFloat(minEl.value); hi = parseFloat(maxEl.value);
      }
      const range = parseFloat(minEl.max) - parseFloat(minEl.min);
      const lp = ((lo - parseFloat(minEl.min)) / range) * 100;
      const rp = 100 - ((hi - parseFloat(minEl.min)) / range) * 100;
      if (fillEl) { fillEl.style.left = lp + '%'; fillEl.style.right = rp + '%'; }
      if (valEl) valEl.textContent = formatter(lo, hi);
      scheduleRefresh();
    };
    [minEl, maxEl].forEach(el => el.addEventListener('input', update));
    update();
  }

  setupRange('price-min', 'price-max', 'price-fill', 'price-val',
    (lo, hi) => '$' + Math.round(lo).toLocaleString() + ' – $' + Math.round(hi).toLocaleString() + (hi >= 50000 ? '+' : ''));
  setupRange('carat-min', 'carat-max', 'carat-fill', 'carat-val',
    (lo, hi) => lo.toFixed(2) + ' – ' + hi.toFixed(2) + ' ct');

  // Reset
  section.querySelector('[data-dfilter-reset]')?.addEventListener('click', () => {
    section.querySelectorAll('.dshape-tile').forEach((t, i) => t.classList.toggle('selected', i === 0));
    section.querySelectorAll('.dfilter-pills .dpill').forEach(p => p.classList.remove('selected'));
    section.querySelectorAll('[data-filter-group="cut"] .dpill').forEach((p, i) => { if (i < 2) p.classList.add('selected'); });
    section.querySelectorAll('[data-filter-group="color"] .dpill').forEach((p, i) => { if (i < 5) p.classList.add('selected'); });
    section.querySelectorAll('[data-filter-group="clarity"] .dpill').forEach((p, i) => { if (i >= 2 && i < 6) p.classList.add('selected'); });
    section.querySelectorAll('[data-filter-group="cert"] .dpill').forEach((p, i) => { if (i < 2) p.classList.add('selected'); });
    section.querySelectorAll('[data-filter-group="polish"] .dpill, [data-filter-group="symmetry"] .dpill').forEach((p, i) => { if (i < 2) p.classList.add('selected'); });
    section.querySelectorAll('[data-filter-group="fluor"] .dpill').forEach((p, i) => { if (i < 2) p.classList.add('selected'); });
    ['price-min', 'carat-min'].forEach(id => { const e = document.getElementById(id); if (e) e.value = e.min; });
    ['price-max', 'carat-max'].forEach(id => { const e = document.getElementById(id); if (e) e.value = e.max; });
    scheduleRefresh();
  });

  // Sort — client-side re-render of the loaded set (no refetch)
  document.getElementById('diamond-sort')?.addEventListener('change', renderResults);

  // View toggle (Grid / List)
  section.querySelectorAll('.dview-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      viewMode = btn.dataset.view === 'list' ? 'list' : 'grid';
      section.querySelectorAll('.dview-btn').forEach(b => b.classList.toggle('active', b === btn));
      renderResults();
    });
  });

  // Load More
  document.querySelector('.pagination .btn')?.addEventListener('click', () => {
    currentPage++;
    fetchDiamonds(currentPage, true);
  });

  // Honor ?shape= deep-link (e.g. customize.html?start=diamond&shape=Pear)
  try {
    const shapeParam = new URLSearchParams(window.location.search).get('shape');
    if (shapeParam) {
      const want = shapeParam.toLowerCase();
      const tile = Array.from(section.querySelectorAll('.dshape-tile'))
        .find(t => (t.dataset.shape || '').toLowerCase() === want);
      if (tile) {
        section.querySelectorAll('.dshape-tile').forEach(t => t.classList.remove('selected'));
        tile.classList.add('selected');
      }
    }
  } catch (e) {}

  // "Shop by Diamond Shape" cards at the top of the page: when the live finder is
  // on the SAME page, clicking a shape filters the inventory below and scrolls to
  // it — no detour to the ring builder. (Cards keep their href as a fallback.)
  document.querySelectorAll('.shape-rail .shape-card').forEach(card => {
    const m = /[?&]shape=([^&]+)/.exec(card.getAttribute('href') || '');
    if (!m) return;
    const want = decodeURIComponent(m[1]).toLowerCase();
    card.addEventListener('click', (e) => {
      const tile = Array.from(section.querySelectorAll('.dshape-tile'))
        .find(t => (t.dataset.shape || '').toLowerCase() === want);
      if (!tile) return;          // shape not in the finder → follow the link as before
      e.preventDefault();
      tile.click();               // selects it and refreshes the grid (existing handler)
      (document.querySelector('.diamond-shape-rail') || section)
        .scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });

  // Initial load
  renderRecentStrip();
  fetchDiamonds(1, false);
})();

// Filter drawer scroll affordance: smooth-scroll on hint click, hide hint at bottom
(function() {
  const drawer = document.getElementById('filter-drawer');
  if (!drawer) return;
  const body = drawer.querySelector('.filter-drawer-body');
  const hint = drawer.querySelector('.filter-scroll-hint');
  if (!body || !hint) return;
  hint.addEventListener('click', () => {
    body.scrollBy({ top: 240, behavior: 'smooth' });
  });
  body.addEventListener('scroll', () => {
    const atBottom = body.scrollHeight - body.scrollTop - body.clientHeight < 20;
    drawer.classList.toggle('scrolled-bottom', atBottom);
  });
})();

// ---------- PLP EXTRAS: working sort dropdown + selectable metal dots ----------
(function() {
  // Sort the product grid. "Best Sellers" restores the original page order.
  document.querySelectorAll('.plp-sort').forEach(sel => {
    const grid = sel.closest('main')?.querySelector('.product-grid') || document.querySelector('.product-grid');
    if (!grid) return;
    const cards = () => [...grid.querySelectorAll(':scope > .product-card')];
    cards().forEach((c, i) => { c.dataset.origOrder = i; });   // remember default order
    const price = el => parseFloat((el.querySelector('.product-price')?.textContent || '').replace(/[^0-9.]/g, '')) || 0;
    sel.addEventListener('change', () => {
      const mode = sel.options[sel.selectedIndex].text.toLowerCase();
      let list = cards();
      if (mode.includes('low to high'))      list.sort((a, b) => price(a) - price(b));
      else if (mode.includes('high to low')) list.sort((a, b) => price(b) - price(a));
      else if (mode.includes('new'))   list.sort((a, b) => b.dataset.origOrder - a.dataset.origOrder);
      else                             list.sort((a, b) => a.dataset.origOrder - b.dataset.origOrder);
      list.forEach(c => grid.appendChild(c));
    });
  });

  // Metal dots on product cards: selecting one must not navigate the card link
  // (capture phase so it wins over the surrounding <a> / setting-card handlers).
  document.addEventListener('click', (e) => {
    const dot = e.target.closest('.card-metal-dot');
    if (!dot) return;
    e.preventDefault();
    e.stopPropagation();
    dot.parentElement.querySelectorAll('.card-metal-dot').forEach(d => d.classList.remove('active'));
    dot.classList.add('active');
    // swap the card photo to this metal's real variant shot (category cards carry data-metals)
    const group = dot.closest('.card-metals');
    let map = null;
    try { map = JSON.parse(group?.dataset.metals || 'null'); } catch (_) {}
    const url = map && map[dot.dataset.metal];
    if (url) {
      const card = dot.closest('.product-card, .pcard');
      const img = card?.querySelector('.product-img img, .pcard-img img, img.primary');
      if (img) {
        img.removeAttribute('srcset');
        img.removeAttribute('sizes');
        img.loading = 'eager';     // never let lazy-load defer the swapped photo
        img.src = url;
      }
    }
    // announce the change (stopPropagation above silences the original click)
    dot.dispatchEvent(new CustomEvent('metal-change', { bubbles: true }));
  }, true);
})();


// ---------- WISHLIST CORE (localStorage; header icon, card hearts, PDP buttons) ----------
(function () {
  const KEY = 'galloWishlist';
  const all = () => { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; } };
  const save = (l) => { try { localStorage.setItem(KEY, JSON.stringify(l)); } catch (e) {} badge(); };
  window.galloWish = {
    all,
    has: (id) => all().some(x => x.id === id),
    toggle(item) { const l = all(); const i = l.findIndex(x => x.id === item.id);
      if (i >= 0) l.splice(i, 1); else l.push(item); save(l); return i < 0; },
    remove(id) { save(all().filter(x => x.id !== id)); },
  };
  const PREFIX = location.pathname.includes('/journal/') ? '../' : '';
  function badge() {
    let btn = document.querySelector('.icon-btn[aria-label="Wishlist"]');
    if (!btn) {
      // some headers ship without the icon — create it next to the cart
      const cartBtn = document.querySelector('.icon-cluster [data-cart-toggle]');
      if (!cartBtn) return;
      btn = document.createElement('button');
      btn.className = 'icon-btn';
      btn.setAttribute('aria-label', 'Wishlist');
      btn.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M12 21s-7.5-4.8-9.5-9C1 8.5 3 5 6.5 5c2 0 3.5 1 5.5 3 2-2 3.5-3 5.5-3C21 5 23 8.5 21.5 12c-2 4.2-9.5 9-9.5 9z"/></svg>';
      cartBtn.parentElement.insertBefore(btn, cartBtn);
    }
    let b = btn.querySelector('.wish-count');
    if (!b) { b = document.createElement('span'); b.className = 'cart-count wish-count'; btn.appendChild(b); }
    const n = all().length;
    b.textContent = n; b.style.display = n ? '' : 'none';
  }
  document.addEventListener('click', (e) => {
    if (e.target.closest('.icon-btn[aria-label="Wishlist"]')) { location.href = (window.GALLO_URL && window.GALLO_URL.shopify) ? '/pages/wishlist' : (PREFIX + 'wishlist.html'); return; }
    const heart = e.target.closest('.pcard-wishlist');
    if (heart) {
      e.preventDefault(); e.stopPropagation();
      const a = heart.closest('a[href*="handle="]') || heart.closest('.pcard, .product-card');
      const href = a?.getAttribute?.('href') || '';
      const hm = /handle=([a-z0-9-]+)/.exec(href);
      let item;
      if (hm && window.GALLO_CATALOG?.byHandle[hm[1]]) {
        const p = GALLO_CATALOG.byHandle[hm[1]];
        item = { id: p.h, title: p.t, price: p.p, img: galloImg(p.i[0], 400), href };
      } else {
        const card = heart.closest('.pcard, .product-card');
        const title = (card?.querySelector('h3, .product-name')?.textContent || 'Saved piece').trim();
        item = { id: title, title,
          price: parseFloat((card?.querySelector('.product-price, .price-tk')?.textContent || '').replace(/[^0-9.]/g, '')) || 0,
          img: card?.querySelector('img')?.src || '', href };
      }
      const added = window.galloWish.toggle(item);
      heart.classList.toggle('active', added);
      window.showToast?.(added ? 'Saved to your wishlist' : 'Removed from wishlist');
      return;
    }
    const saveBtn = e.target.closest('button, a');
    if (saveBtn && /save to wishlist/i.test(saveBtn.textContent || '')) {
      e.preventDefault();
      const handle = new URLSearchParams(location.search).get('handle');
      const p = handle && window.GALLO_CATALOG?.byHandle[handle];
      const title = p ? p.t : (document.querySelector('.pdp-config h1')?.textContent || '').trim();
      const item = { id: p ? p.h : title, title,
        price: p ? p.p : parseFloat((document.querySelector('.pdp-config .price')?.textContent || '').replace(/[^0-9.]/g, '')) || 0,
        img: p ? galloImg(p.i[0], 400) : (document.querySelector('.gallery-grid img')?.src || ''),
        href: (window.GALLO_URL && window.GALLO_URL.shopify) ? (location.pathname + location.search) : (location.pathname.split('/').pop() + location.search) };
      const added = window.galloWish.toggle(item);
      window.showToast?.(added ? 'Saved to your wishlist' : 'Removed from wishlist');
    }
  });
  badge();
})();

// ---------- MOBILE NAVIGATION (hamburger + slide-in drawer; nav was invisible <768px) ----------
(function () {
  const nav = document.querySelector('.nav-row ul');
  const logoRow = document.querySelector('.logo-row-inner');
  if (!nav || !logoRow) return;
  const PREFIX = location.pathname.includes('/journal/') ? '../' : '';
  const btn = document.createElement('button');
  btn.className = 'icon-btn mobile-nav-btn';
  btn.setAttribute('aria-label', 'Menu');
  btn.innerHTML = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M3 6h18M3 12h18M3 18h18"/></svg>';
  logoRow.insertBefore(btn, logoRow.firstChild);
  const links = [...nav.querySelectorAll(':scope > li > a')]
    .map(a => ({ text: a.textContent.trim(), href: a.getAttribute('href') }));
  links.push({ text: 'Visit the Showroom', href: PREFIX + 'visit.html' },
             { text: 'Contact', href: PREFIX + 'contact.html' },
             { text: 'FAQ', href: PREFIX + 'faq.html' });
  const drawer = document.createElement('aside');
  drawer.className = 'mobile-nav';
  drawer.setAttribute('aria-label', 'Site menu');
  drawer.innerHTML = '<div class="mobile-nav-head"><span>MENU</span>' +
    '<button class="icon-btn" data-mnav-close aria-label="Close menu"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M6 6l12 12M18 6L6 18"/></svg></button></div>' +
    '<nav><ul>' + links.map(l => '<li><a href="' + l.href + '">' + l.text + '</a></li>').join('') + '</ul></nav>' +
    '<a href="' + PREFIX + 'visit.html#book" class="btn btn-primary button-text" style="margin:16px;text-align:center">Book a Consultation</a>';
  const backdrop = document.createElement('div');
  backdrop.className = 'mobile-nav-backdrop';
  document.body.append(drawer, backdrop);
  const open = () => { drawer.classList.add('open'); backdrop.classList.add('open'); document.body.style.overflow = 'hidden'; };
  const close = () => { drawer.classList.remove('open'); backdrop.classList.remove('open'); document.body.style.overflow = ''; };
  btn.addEventListener('click', open);
  backdrop.addEventListener('click', close);
  drawer.addEventListener('click', (e) => { if (e.target.closest('[data-mnav-close]')) close(); });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && drawer.classList.contains('open')) close(); });
})();


// ---------- DISPLAY TITLE-CASE (catalog titles arrive ALL-CAPS from Shopify) ----------
window.galloTitleCase = function (s) {
  if (!s) return s;
  const letters = s.replace(/[^A-Za-z]/g, '');
  const upper = s.replace(/[^A-Z]/g, '').length;
  if (!letters.length || upper / letters.length < 0.7) return s;   // not a SHOUTING title
  return s.toLowerCase().replace(/\b([a-z])/g, (m, c) => c.toUpperCase())
    .replace(/\b(\d+(?:\.\d+)?)ct\b/gi, '$1ct').replace(/\bIgi\b/g, 'IGI').replace(/\bGia\b/g, 'GIA')
    .replace(/(\d)([A-Z])/g, '$1$2');
};

// ---------- STICKY "YOUR RING" BAR (builder step 2) ----------
(function () {
  if (!document.querySelector('[data-customizer-stepper]')) return;
  function state() {
    try { return JSON.parse(sessionStorage.getItem('galloCustomizer')) ||
                 JSON.parse(sessionStorage.getItem(Object.keys(sessionStorage).find(k => /customiz/i.test(k)))) || {}; }
    catch (e) { return {}; }
  }
  const money = (v) => '$' + Math.round(v || 0).toLocaleString();
  function update() {
    const s = state();
    let bar = document.getElementById('ring-bar');
    const show = s.step === 2 && (s.setting || s.diamond);
    if (!show) { bar?.remove(); document.body.classList.remove('has-ring-bar'); return; }
    if (!bar) { bar = document.createElement('div'); bar.id = 'ring-bar'; document.body.appendChild(bar); }
    document.body.classList.add('has-ring-bar');
    const parts = [];
    if (s.setting) parts.push('<span><strong>' + s.setting.name + '</strong> ' + money(s.setting.price) + '</span>');
    parts.push(s.diamond
      ? '<span><strong>' + parseFloat(s.diamond.carat).toFixed(2) + 'ct ' + (s.diamond.shape || '') + '</strong> ' + money(s.diamond.price) + '</span>'
      : '<span class="muted">now choose your diamond…</span>');
    const total = (s.setting?.price || 0) + (s.diamond?.price || 0);
    bar.innerHTML = '<div class="rb-items">' + parts.join('<span class="rb-sep">+</span>') + '</div>' +
      '<div class="rb-right"><span class="rb-total">' + money(total) + (s.diamond ? '' : ' so far') + '</span>' +
      (s.setting && s.diamond ? '<button type="button" class="btn btn-primary button-text" onclick="galloCustomizer.goToStep(3)">Review →</button>' : '') + '</div>';
  }
  update();
  document.addEventListener('click', () => setTimeout(update, 80));
})();

// ---------- MOBILE STICKY ADD-TO-CART (product pages) ----------
(function () {
  const primary = document.querySelector('.cta-stack .btn-primary') || document.getElementById('set-select');
  const priceEl = document.querySelector('.pdp-config .price, #set-price');
  if (!primary || !priceEl) return;
  const bar = document.createElement('div');
  bar.id = 'm-atc';
  const btn = document.createElement('button');
  btn.className = 'btn btn-primary button-text';
  const sync = () => {
    bar.querySelector('.p')?.remove();
    const p = document.createElement('span'); p.className = 'p';
    p.textContent = (priceEl.textContent || '').trim().split(' ')[0];
    bar.prepend(p);
    btn.textContent = /select/i.test(primary.textContent) ? 'Select This Setting' : 'Add to Cart';
  };
  btn.addEventListener('click', () => primary.click());
  bar.appendChild(btn);
  document.body.appendChild(bar);
  sync();
  new IntersectionObserver((es) => {
    bar.classList.toggle('show', !es[0].isIntersecting);
    sync();
  }, { rootMargin: '0px' }).observe(primary);
})();

// ---------- TEXT A JEWELER (floating, the anti-chatbot) ----------
(function () {
  const PHONE = '19738907000';
  const fab = document.createElement('div');
  fab.id = 'text-jeweler';
  fab.innerHTML =
    '<div class="tj-menu" hidden>' +
    '<a href="sms:+' + PHONE + '">💬 Text us</a>' +
    '<a href="https://wa.me/' + PHONE + '" target="_blank" rel="noopener">WhatsApp</a>' +
    '<a href="tel:+' + PHONE + '">📞 Call 973-890-7000</a>' +
    '<p>A real person answers — photos of inspiration welcome.</p></div>' +
    '<button type="button" class="tj-btn" aria-label="Text a jeweler">💬 <span>Text a Jeweler</span></button>';
  document.body.appendChild(fab);
  const menu = fab.querySelector('.tj-menu');
  fab.querySelector('.tj-btn').addEventListener('click', () => { menu.hidden = !menu.hidden; });
  document.addEventListener('click', (e) => { if (!fab.contains(e.target)) menu.hidden = true; });
})();


// ---------- (2) FINANCING LINE on product listing cards ("From $X/mo") ----------
(function () {
  document.querySelectorAll('.product-card .product-price, .pcard .price-tk').forEach(el => {
    if (el.parentElement.querySelector('.product-mo')) return;
    const amt = parseFloat((el.textContent || '').replace(/[^0-9.]/g, ''));
    if (!amt || amt < 300) return;
    const mo = document.createElement('p');
    mo.className = 'product-mo';
    mo.textContent = 'From $' + Math.ceil(amt / 12).toLocaleString() + '/mo';
    el.insertAdjacentElement('afterend', mo);
  });
})();


// ---------- (4) HOMEPAGE LIVE DIAMOND STRIP ----------
(function () {
  const host = document.getElementById('home-diamonds');
  if (!host) return;
  const PROXY = 'https://gallo-diamonds.gallojewelry.workers.dev';
  const HOVER_OK = !window.matchMedia || window.matchMedia('(hover:hover) and (pointer:fine)').matches;
  const grid = host.querySelector('.home-dia-grid');
  const money = (v) => '$' + Math.round(v).toLocaleString();
  function dayShuffle(arr) {
    const d = new Date();
    let seed = d.getFullYear() * 1000 + d.getMonth() * 31 + d.getDate();
    const rnd = () => { seed = (seed * 9301 + 49297) % 233280; return seed / 233280; };
    const a = arr.slice();
    for (let i = a.length - 1; i > 0; i--) { const j = Math.floor(rnd() * (i + 1)); [a[i], a[j]] = [a[j], a[i]]; }
    return a;
  }
  function wireHover() {
    grid.querySelectorAll('.home-dcard').forEach(card => {
      const media = card.querySelector('.dcard-media');
      let mounted = false;
      card.addEventListener('mouseenter', () => {
        if (!mounted) {
          mounted = true;
          const f = document.createElement('iframe');
          f.src = PROXY + '/spin-view?v=7&u=' + encodeURIComponent(media.dataset.video);
          f.setAttribute('scrolling', 'no'); f.setAttribute('tabindex', '-1'); f.setAttribute('aria-hidden', 'true');
          media.appendChild(f);
        }
        media.classList.add('is-spinning');
      });
      card.addEventListener('mouseleave', () => media.classList.remove('is-spinning'));
    });
  }
  let started = false;
  function load() {
    if (started) return; started = true;
    fetch(PROXY + '?type=Lab_grown_Diamond&size_from=0.9&size_to=2.6&page_size=40&with_images=true&show_unavailable=false')
      .then(r => r.json()).then(data => {
        const all = (data.diamonds || []).filter(d => d.image_url && d.video_url && (d.total_sales_price || d.price));
        const total = data.total_diamonds_found || all.length;
        const cnt = host.querySelector('[data-dia-count]'); if (cnt && total) cnt.textContent = total.toLocaleString() + '+';
        if (!all.length) { host.style.display = 'none'; return; }
        const shuffled = dayShuffle(all), picked = [], seen = new Set();
        for (const d of shuffled) { if (picked.length >= 4) break; const sh = (d.shape || '').toLowerCase(); if (seen.has(sh)) continue; seen.add(sh); picked.push(d); }
        for (const d of shuffled) { if (picked.length >= 4) break; if (!picked.includes(d)) picked.push(d); }
        grid.innerHTML = picked.map(d => {
          const carat = d.size ? parseFloat(d.size).toFixed(2) : '';
          const specs = [d.color, d.clarity, d.lab].filter(Boolean).join(' · ');
          const shape = (d.shape || 'Diamond').replace(/"/g, '');
          // Route the still through the worker (reliable + edge-cached); on failure
          // swap in a clean placeholder so the card is never blank.
          const onerr = "this.style.display='none';this.parentNode.insertAdjacentHTML('afterbegin','<div class=\\'dcard-noimg\\'>" + shape + "</div>')";
          return '<a class="dcard home-dcard" href="' + ((window.GALLO_URL && window.GALLO_URL.diamonds) || 'diamonds.html') + '">' +
            '<div class="dcard-media" data-video="' + d.video_url + '" data-id="' + d.id + '">' +
            '<img src="' + PROXY + '/img?u=' + encodeURIComponent(d.image_url) + '" alt="' + carat + ' ct ' + shape + ' lab diamond" loading="lazy" onerror="' + onerr + '">' +
            '<span class="dcard-360">360°</span></div>' +
            '<div class="dcard-body"><p class="dcard-title">' + carat + ' ct ' + (d.shape || '') + ' Lab Diamond</p>' +
            (specs ? '<p class="dcard-specs">' + specs + '</p>' : '') +
            '<p class="dcard-price">' + money(d.total_sales_price || d.price) + '</p></div></a>';
        }).join('');
        if (HOVER_OK) wireHover();
      }).catch(() => { host.style.display = 'none'; });
  }
  // price-index tie-in (independent; removes the stat if unavailable)
  fetch(PROXY + '/price-index').then(r => r.json()).then(j => {
    const r = j && j.latest && j.latest.shapes && j.latest.shapes.Round;
    const el = host.querySelector('[data-dia-avg]');
    if (el && r) el.textContent = '$' + Math.round(r.avgPpc).toLocaleString() + '/ct';
    else host.querySelector('.home-dia-stat')?.remove();
  }).catch(() => host.querySelector('.home-dia-stat')?.remove());
  if ('IntersectionObserver' in window) {
    new IntersectionObserver((es, ob) => { if (es[0].isIntersecting) { load(); ob.disconnect(); } }, { rootMargin: '400px' }).observe(host);
  } else load();
})();


// ---------- STICKY CTA yields to the footer (same booking link lives there) ----------
(function () {
  const cta = document.querySelector('.sticky-cta');
  const foot = document.querySelector('.site-footer') || document.querySelector('footer');
  if (!cta || !foot || !('IntersectionObserver' in window)) return;
  new IntersectionObserver((es) => {
    cta.classList.toggle('is-off', es.some(e => e.isIntersecting));
  }).observe(foot);
})();
